import LocationBaseController from '../common/location.base.controller'
import AppConstants from '../../../config/app.constants';
import moment from 'moment';
import _ from 'lodash';

class LocationEditController extends LocationBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, LocationService, Modal, $translate, $stateParams, BranchService, CustomerService, NgMap, RouteService, ContractService,
		$q, LocationDeliveryService, ShiptypeService, UserBranchService, LocationBranchService, $scope, DateUtil, Configs, SetupService, OrderViewService,
		CommonLayoutService, DenominationService, BranchFundingSourceService, BranchFundingSourceOrderProfileService, StopSchedulingService, CostCenterService, AtmMakesService) {

		super(Auth, $state, User, LocationService, Modal, $translate, $stateParams)
		this.pageName = `location`

		this.isPMSuspended = (val) => {
			if (!val) return false;
			if (val && typeof val === 'object' && val.isSuspended !== undefined) {
				return val.isSuspended;
			}
			const id = (val && typeof val === 'object') ? val.Value : val;
			const pm = (this.pmSearchList || []).find(p => p.Value === id);
			return pm && pm.isSuspended;
		}

		this.rawId = ''
		this.NgMap = NgMap
		this.ContractService = ContractService
		this.BranchService = BranchService
		this.CustomerService = CustomerService
		this.RouteService = RouteService
		this.LocationDeliveryService = LocationDeliveryService
		this.ShiptypeService = ShiptypeService
		this.UserBranchService = UserBranchService;
		this.LocationBranchService = LocationBranchService;
		this.SetupService = SetupService;
		this.CommonLayoutService = CommonLayoutService;
		this.BranchFundingSourceService = BranchFundingSourceService;
		this.BranchFundingSourceOrderProfileService = BranchFundingSourceOrderProfileService;
		this.DenominationService = DenominationService;
		this.StopSchedulingService = StopSchedulingService;
		this.CostCenterService = CostCenterService;
		this.AtmMakesService = AtmMakesService;
		this.OrderViewService = OrderViewService;
		this.atmMakesList = [];
		this.DateUtil = DateUtil;
		this.Configs = Configs;
		this.$scope = $scope;
		this.$q = $q;
		this.customer = []
		this.branch = []
		this.locations = []
		this.contracts = []
		this.contractDays = []
		this.costCenterList = []
		this.locationZoneList = []
		this.totalCostomers = 0;
		this.totalContracts = 0;
		this.locationSlots = [];
		this.denominations = [];
		this.showAddSlotForm = false;
		this.pickupRequestTimes = [];
		this.model = {
			location: 'LOC',
			status: true,
			customer: '',
			costCenter: '',
			selectedLocationZones: [],
			comments: null,
			defaultBranch: null,
			loggedInUser: User.getUser().id,
			branchId: User.getUser().branchId,
			_address: 'add',
			_city: 'city',
			_state: null,
			_zip: 'zip',
			refId: null,
			_poc: 'poc',
			pocPhone: 'phone',
			pocEmail: 'a@a.a',
			RNdeliveries: true,
			RNpickups: false,
			RNnoPickup: false,
			RNzeroPickup: false,
			deliverBagOutPiece: false,
			individualBagout: false,
			centralBank: false,
			selectedDenomination: [],
			locationBalanceActive: [],
			Mon: {
				routeId: '',
				stops: '',
				options: ''
			},
			Tue: {
				routeId: '',
				stops: '',
				options: ''
			},
			Wed: {
				routeId: '',
				stops: '',
				options: ''
			},
			Thu: {
				routeId: '',
				stops: '',
				options: ''
			},
			Fri: {
				routeId: '',
				stops: '',
				options: ''
			},
			Sat: {
				routeId: '',
				stops: '',
				options: ''
			},
			Sun: {
				routeId: '',
				stops: '',
				options: ''
			},
			Hol: {
				routeId: '',
				stops: '',
				options: ''
			},
			seasonStart: null,
			seasonEnd: null,
			startTime: null,
			endTime: null,
			_type: 'ATM',
			keyId: '',
			maxDepositAmount: 0,
			// deliveryBackoutTimes: true,
			roundedDeposits: false,
			codAllow: true,
			allowMulti: false,
			bulkTransfer: false,
			individualBagout: false,
			deliveryLoc1: null,
			deliveryLoc2: null,
			deliveryLocCoin: null,
			deliveryLocCod: null,
			lastTransaction: true,
			_leave: true,
			verifyToTruck: true,
			verifyCoinToTruck: false,
			maxCassettes: null,
			atmCassette: false,
			packCoinSeparately: false,
			captureDenomStc: false,
			TRdeliveries: true,
			TRpickups: true,
			latitude: 41.74,
			longitude: -102.18,
			sameForAll: false,
			lockType: null,
			openTimeSun: null,
			closeTimeSun: null,
			openTimeMon: null,
			closeTimeMon: null,
			openTimeTue: null,
			closeTimeTue: null,
			openTimeWed: null,
			closeTimeWed: null,
			openTimeThu: null,
			closeTimeThu: null,
			openTimeFri: null,
			closeTimeFri: null,
			openTimeSat: null,
			closeTimeSat: null,
			openTimeHoliday: null,
			closeTimeHoliday: null,
			isSameOperationTime: false,
			ATMTransfer: false,
			OTCGeoFence: false,
			closeReq: false,
			closeEndOfStop: false,
			zoneRouting: false,
			stopPriority: null,
			model: null,
			serialNumber: null,
			secondaryLock: false,
			secondaryLockId: null,
			secondaryLockType: null,
			secondaryLockOTCCompanyName: null,
			secondaryLockCloseReq: false,
			secondaryLockAutoOpen: false,
			enableOrderProfile: false,
			fundingSourceObj: {
				results: [],
				totalRecords: 0,
				loading: false,
				selectedFundingSource: null
			},
			orderProfileObj: {
				results: [],
				totalRecords: 0,
				loading: false,
				selectedOrderProfile: null
			},
			denominationSourceObj: {
				results: [],
				totalRecords: 0,
				loading: false,
				selectedDenomination: []
			},
			locationSlotDenominations: {
				results: [],
				totalRecords: 0,
			},
			handleAtmLikeRegular: false,
			handleAtmLikeRegularLocationType: ['ATM', 'LOCKER', 'DELIVERY', 'BANK', 'ON_CALL', "NO_SHIP_NO_GO"],
			idBatchImport: null,
			idBagoutExport: null,
			idBagoutDepositExport: null,
			idOTCLock: null,
			scheduledLocations: [],
			deleteScheduledLocationIds: [],
			routeListObj: {
				result: [],
				totalRecords: 0
			},
			NFCLock: false,
			country: null,
			NFCScan: false,
			NFCTagId: null,
			isNonUSLocation: false,
			customerCostCenter: null,
			recurringStops: [],
			deletedRecurringStops: [],
			make: [],
			accountNumber: null,
			machineOwner: null,
			bankSourceId: null,
			FLMProvider: null,
			SLMProvider: null,
			optional1: null,
			optional2: null,
			optional3: null,
			bankWeek: null,
			frequencyOptions: null,
			dayOfWeekOptions: null,
			contractExpirationDate: null,
			forecastingStrategy: null,
			liabilityThreshold: null,
			securityThreshold: null,
			atmEmptyAtCalculationMethod: null,
			aecPercentChangeValue: null,
			aecPercentChangePeriodA: null,
			aecPercentChangePeriodB: null,
			aecWeightedAvgWeightA: null,
			aecWeightedAvgPeriodA: null,
			aecWeightedAvgWeightB: null,
			aecWeightedAvgPeriodB: null,
			aecSinglePeriod: null,
			addToSwapRatio: null,
			deliveryCutOff: false,
			deliveryCutOffTime: null,
			lastRouteStop: false,
			targetStopTime: null,
			printDeliveryManifest: false,
			balanceType: 'DENOMINATION',
			forecastingFlowDirection: 'EMPTY',
			flowThreshold: 0.2,
			podReceipt: false,
			locationSlots: [],
			sendManifestOnDelivery: false,
			manifestRecipientEmail: '',
			zeroAmountPickupRecipientEmail: '',
			pickupSLA: false,
			pickupSLATime: null,
			autoRerouteMissed: false,
			packResidual: true,
			coinPermitted: false,
			bagoutEnabled: false,
			isTransferHoldLocation: false,
			singleBranch: null,
			fallbackFillRate: 0,
			preventativeMaintenanceId: null,
		}

		this.days = [{
			label: this.$translate.instant('location.mon'),
			value: 'Mon'
		},
		{
			label: this.$translate.instant('location.tues'),
			value: 'Tue'
		},
		{
			label: this.$translate.instant('location.wed'),
			value: 'Wed'
		},
		{
			label: this.$translate.instant('location.thurs'),
			value: 'Thu'
		},
		{
			label: this.$translate.instant('location.fri'),
			value: 'Fri'
		},
		{
			label: this.$translate.instant('location.sat'),
			value: 'Sat'
		},
		{
			label: this.$translate.instant('location.sun'),
			value: 'Sun'
		},
		{
			label: this.$translate.instant('location.hol'),
			value: 'Hol'
		},
		]

		// this.sameForAll = false
		this.today = moment.utc().format(),
			this.defBackoutTimes = false
		this._types = [{
			label: this.$translate.instant('location_types.DELIVERY'),
			value: 'DELIVERY'
		},
		{
			label: this.$translate.instant('routeControl.ATM'),
			value: 'ATM'
		},
		{
			label: this.$translate.instant('routeControl.nsng'),
			value: 'NO_SHIP_NO_GO'
		},
		{
			label: this.$translate.instant('routeControl.regular'),
			value: 'REGULAR'
		},
		{
			label: this.$translate.instant('routeControl.bank'),
			value: 'BANK'
		},
		{
			label: this.$translate.instant('routeControl.on_call'),
			value: 'ON_CALL'
		},
		{
			label: this.$translate.instant('routeControl.internal'),
			value: 'INTERNAL'
		},
		{
			label: this.$translate.instant('location_types.LOCKER'),
			value: 'LOCKER'
		},
		{
			label: this.$translate.instant('routeControl.truck'),
			value: 'TRUCK'
		},
		{
			label: this.$translate.instant('routeControl.tanker'),
			value: 'TANKER'
		},
		{
			label: this.$translate.instant('routeControl.carrier'),
			value: 'CARRIER'
		},
		{
			label: this.$translate.instant('routeControl.window'),
			value: 'WINDOW'
		},
		{
			label: this.$translate.instant('location_types.VAULT'),
			value: 'VAULT'
		}
		]

		this.day = {
			routeId: [],
			stops: [{
				label: 'Stop1',
				value: 'stop1'
			},
			{
				label: 'Stop2',
				value: 'stop2'
			}
			],
			options: [{
				label: 'Weekly',
				value: 'Weekly'
			},
			{
				label: 'Bi-Monthly',
				value: 'Bi_Monthly'
			},
			{
				label: 'Monthly',
				value: 'monthly'
			},
			{
				label: 'Seasonal',
				value: 'Seasonal'
			}]
		}

		this.dateFormat = 'MM/dd';
		this.lockTypes = CommonLayoutService.lockTypes();

		this.addToSwapRatioOptions = [
			{
				label: 'Always Add',
				value: 'ALWAYS_ADD'
			},
			{
				label: 'Always Swap',
				value: 'ALWAYS_SWAP'
			},
			{
				label: '2 Adds Between Swap',
				value: '2_ADDS_BETWEEN_SWAP'
			},
			{
				label: '3 Adds Between Swap',
				value: '3_ADDS_BETWEEN_SWAP'
			},
			{
				label: '4 Adds Between Swap',
				value: '4_ADDS_BETWEEN_SWAP'
			},
			{
				label: '5 Adds Between Swap',
				value: '5_ADDS_BETWEEN_SWAP'
			},
			{
				label: '6 Adds Between Swap',
				value: '6_ADDS_BETWEEN_SWAP'
			}
		]

		// this.OTCCompanyNameList = [
		// 	{
		// 		label: 'First Premier',
		// 		value: 'FirstPremier'
		// 	},
		// 	{
		// 		label: 'VTS',
		// 		value: 'VTS'
		// 	},
		// 	{
		// 		label: 'DevCo',
		// 		value: 'DevCo'
		// 	},
		// 	{
		// 		label: 'Witzco',
		// 		value: 'witzco'
		// 	}
		// ]

		this.states = [
			{
				label: 'Alabama', value: 'AL'
			},
			{
				label: 'Alaska', value: 'AK'
			},
			{
				label: 'American Samoa', value: 'AS'
			},
			{
				label: 'Arizona', value: 'AZ'
			},
			{
				label: 'Arkansas', value: 'AR'
			},
			{
				label: 'California', value: 'CA'
			},
			{
				label: 'Colorado', value: 'CO'
			},
			{
				label: 'Connecticut', value: 'CT'
			},
			{
				label: 'Delaware', value: 'DE'
			},
			{
				label: 'District Of Columbia', value: 'DC'
			},
			// {
			// 	label: 'Federated States Of Micronesia', value: 'FM'
			// },
			{
				label: 'Florida', value: 'FL'
			},
			{
				label: 'Georgia', value: 'GA'
			},
			{
				label: 'Guam', value: 'GU'
			},
			{
				label: 'Hawaii', value: 'HI'
			},
			{
				label: 'Idaho', value: 'ID'
			},
			{
				label: 'Illinois', value: 'IL'
			},
			{
				label: 'Indiana', value: 'IN'
			},
			{
				label: 'Iowa', value: 'IA'
			},
			{
				label: 'Kansas', value: 'KS'
			},
			{
				label: 'Kentucky', value: 'KY'
			},
			{
				label: 'Louisiana', value: 'LA'
			},
			{
				label: 'Maine', value: 'ME'
			},
			{
				label: 'Marshall Islands', value: 'MH'
			},
			{
				label: 'Maryland', value: 'MD'
			},
			{
				label: 'Massachusetts', value: 'MA'
			},
			{
				label: 'Michigan', value: 'MI'
			},
			{
				label: 'Minnesota', value: 'MN'
			},
			{
				label: 'Mississippi', value: 'MS'
			},
			{
				label: 'Missouri', value: 'MO'
			},
			{
				label: 'Montana', value: 'MT'
			},
			{
				label: 'Nebraska', value: 'NE'
			},
			{
				label: 'Nevada', value: 'NV'
			},
			{
				label: 'New Hampshire', value: 'NH'
			},
			{
				label: 'New Jersey', value: 'NJ'
			},
			{
				label: 'New Mexico', value: 'NM'
			},
			{
				label: 'New York', value: 'NY'
			},
			{
				label: 'North Carolina', value: 'NC'
			},
			{
				label: 'North Dakota', value: 'ND'
			},
			{
				label: 'Northern Mariana Islands', value: 'MP'
			},
			{
				label: 'Ohio', value: 'OH'
			},
			{
				label: 'Oklahoma', value: 'OK'
			},
			{
				label: 'Oregon', value: 'OR'
			},
			{
				label: 'Palau', value: 'PW'
			},
			{
				label: 'Pennsylvania', value: 'PA'
			},
			{
				label: 'Puerto Rico', value: 'PR'
			},
			{
				label: 'Rhode Island', value: 'RI'
			},
			{
				label: 'South Carolina', value: 'SC'
			},
			{
				label: 'South Dakota', value: 'SD'
			},
			{
				label: 'Tennessee', value: 'TN'
			},
			{
				label: 'Texas', value: 'TX'
			},
			{
				label: 'Utah', value: 'UT'
			},
			{
				label: 'Vermont', value: 'VT'
			},
			{
				label: 'Virgin Islands', value: 'VI'
			},
			{
				label: 'Virginia', value: 'VA'
			},
			{
				label: 'Washington', value: 'WA'
			},
			{
				label: 'West Virginia', value: 'WV'
			},
			{
				label: 'Wisconsin', value: 'WI'
			},
			{
				label: 'Wyoming', value: 'WY'
			},
		];

		this.stopPriorityList = this.CommonLayoutService.priorityList();

		this.operationDays = [{
			label: this.$translate.instant('location.mon'),
			value: 'Mon'
		},
		{
			label: this.$translate.instant('location.tues'),
			value: 'Tue'
		},
		{
			label: this.$translate.instant('location.wed'),
			value: 'Wed'
		},
		{
			label: this.$translate.instant('location.thurs'),
			value: 'Thu'
		},
		{
			label: this.$translate.instant('location.fri'),
			value: 'Fri'
		},
		{
			label: this.$translate.instant('location.sat'),
			value: 'Sat'
		},
		{
			label: this.$translate.instant('location.sun'),
			value: 'Sun'
		},
		{
			label: this.$translate.instant('location.hol'),
			value: 'Holiday'
		}]

		this.manifestTypeList = [
			{
				value: 'bin_manifest_transport', label: 'Bin Manifest Transport'
			},
			{
				value: 'bagout_manifest', label: 'Bagout Manifest'
			},
			{
				value: 'delivery_manifest', label: 'Delivery Manifest'
			}
		];
		this.manifestFileType = [
			{ value: 'EXCEL', label: 'EXCEL' },
			{ value: 'PDF', label: 'PDF' }
		];

		this._map = this._map.bind(this);
		this.onMarkerDragEnd = this.onMarkerDragEnd.bind(this);
		this.total = [];
		this.dayArray = [];
		this.unshiftSelected = true;
		this.isValidDirective = true;
		this.renderDirective = false;
		this.custNotSelectError = false;
		this.locationType = ['TANKER', 'TRUCK', 'INTERNAL', 'WINDOW'];
		this.hasACL = {};
		this.openTime = 'openTime';
		this.closeTime = 'closeTime';
		this.OTCCompanyNameList = [];
		this.currentLocationAddressObj = {};
		this.locationAddressUpdateObj = {};
		this.currentlyAssignedRoutes = {};
		this.updatedAssignedRoutes = {};
		this.currentlyAssignedDeliveryToLocation = {};
		this.updatedDeliveryToLocation = {};
		this.isLocationAddressChanged = false;
		this.isRouteAssignmentChanged = false;
		this.isDeliveryToLocationUpdated = false;
		this.locationHistory = {};
		this.currentlyAssignedLocationStatus = {};
		this.isLocationStatus = false;
		this.currentlyAssignedAllBranches = {};
		this.isAllBranchesChanged = false;
		this.currentlyAssignedDefaultBranch = {};
		this.isDefaultBranchChanged = false;
		this.currentlyAssignedBatchImport = {};
		this.isBatchImportChanged = false;
		this.currentlyAssignedBagoutExport = {};
		this.isBagoutExportChanged = false;
		this.currentlyAssignedHandleAtmLikeRegular = {};
		this.isHandleAtmLikeRegular = false;

		this.dateOptions = {
			formatDayTitle: 'MMMM',
			maxMode: "day"
		};

		this.passWdIcon = {};
		this.passwordStats = ['primary', 'secondary'];
		this.pendingStopsChangesObj = {
			results: [],
			total: 0,
			loading: false
		};
		this.customerCostCenterObj = {
			results: [],
			total: 0
		};

		this.intervalList = this.CommonLayoutService.intervalList();
		this.bankWeekList = this.CommonLayoutService.bankWeekList();
		this.frequencyList = this.CommonLayoutService.frequency();
		this.weekDayList = this.CommonLayoutService.dayOfWeek();
		this.combinedRouteIntervals = this.CommonLayoutService.combinedRouteIntervals();
		this.foreCastingList = this.CommonLayoutService.forecastingMethod();
		this.combinedRoutes = [];
		this.originalCombinedRoutes = [];
		this.dayMap = this.CommonLayoutService.dayMap();
		this.LocationService = LocationService;
		this.locationRecurringLoad = [];
		this.originalLocationRecurringLoad = [];
		this.recurringLoadSnapshotTaken = false;
		this.isValidRecurringLoad = true;
		this.atmEmptyAtCalculationMethodList = this.CommonLayoutService.atmEmptyAtCalculationMethod();
		this.fallbackFillRateDisplay = "0.0000%"
		this.balanceTypes = [
			{ label: 'Denomination', value: 'DENOMINATION' },
			{ label: 'Percentage', value: 'PERCENTAGE' },
		];
		this.forecastingFlowDirection = [
			{ label: 'Fill', value: 'FILL' },
			{ label: 'Empty', value: 'EMPTY' },
		];
	}

	_map($event) {
		this.model.latitude = $event.latLng.lat()
		this.model.longitude = $event.latLng.lng()
		if (this.model.latitude, this.model.longitude) {
			this.getAddressFromLatLng(this.model.latitude, this.model.longitude)
		}
	}

	changeCustomer() {
		if (this.model.customer) {
			if (this.model.sameForAll) {
				this.custNotSelectError = false;
				// this.clearContractDays()
			}
			this.CustomerService.get(this.model.customer.Value)
				.then((data) => {
					// this.loadDays(data)
					if (this.model.sameForAll) this.clearContractDays();
				})
		} else {
			if (this.model.sameForAll) {
				this.uncheckSameForAll();
				this.clearContractDays();
			}
		}
	}

	clearContractDays() {
		for (let day in this.contractDays) {
			if (this.contractDays[day]) {
				for (let key in this.model[day]) {
					this.model[day][key] = ''
				}
			}
		}
		// this.contractDays = []
	}
	// loadDays(data) {
	// 	this.contractDays = []
	// 	for (let key in data) {
	// 		if (key.toString().includes('serviceSchedule')) {
	// 			this.contractDays[key.toString().replace('serviceSchedule', '')] = data[key]
	// 		}
	// 	}
	// }
	sameAll() {

		this.contractDays = [];
		this.days.forEach((data) => {
			this.contractDays[data.value] = true;
		})

		if (this.model.sameForAll) {
			this.custNotSelectError = false;
			for (let day in this.contractDays) {
				if (this.contractDays[day]) {
					for (let key in this.model[day]) {
						this.model[day][key] = ''
					}
				}
			}
		}
	}
	updateAll(selectedDay, opt) {
		if (this.model.sameForAll) {
			if (this.contractDays[selectedDay]) {
				for (let day in this.contractDays) {
					if (this.contractDays[day]) {
						this.model[day][opt] = this.model[selectedDay][opt];
					}
				}
			}
		}
	}
	uncheckSameForAll() {
		this.custNotSelectError = true;
		setTimeout(() => {
			this.custNotSelectError = false;
			this.model.sameForAll = false;
			this.$scope.$digest();
		}, 4000);
	}

	getDate(time) {
		if (!time) {
			return time;
		}
		time = time.split(':');

		let d = new Date();

		d.setUTCHours(+time[0]);
		d.setUTCMinutes(time[1]);
		d.setUTCSeconds(0);
		d.setUTCMilliseconds(0);

		return d;
	}

	getNonUTCDate(time) {
		if (!time) {
			return time;
		}

		time = time.split(':');

		let d = new Date();

		d.setHours(+time[0]);
		d.setMinutes(time[1]);
		d.setSeconds(0);
		d.setMilliseconds(0);

		return d;
	}

	locationSearchObj() {
		let selectedBranch = this.model.branch.map((branch) => branch.branchId)
		const searchObj = {
			queryJSON: {
				rules: [
					{
						field: 'id',
						condition: '!=',
						data: this.rawId
					},
					{
						field: 'branchId',
						condition: 'IN',
						data: selectedBranch
					},
					{
						field: 'active',
						condition: '=',
						data: true
					},
					{
						group: {
							rules: [
								{
									field: 'locationType',
									condition: '=',
									data: 'DELIVERY'
								},
								{
									field: 'locationType',
									condition: '=',
									data: 'BANK'
								},
								{
									field: 'locationType',
									condition: '=',
									data: 'ATM'
								},
								{
									field: 'locationType',
									condition: '=',
									data: 'REGULAR'
								},
								{
									field: 'locationType',
									condition: '=',
									data: 'ON_CALL'
								},
								{
									field: 'locationType',
									condition: '=',
									data: 'NO_SHIP_NO_GO'
								}
							],
							operator: 'OR',
						}
					}
				],
				operator: 'AND'
			}
		};
		return searchObj.queryJSON.rules.length ? searchObj : null;
		// }, 1000);
	}

	// changeBranch() {
	// 	this.total = [];
	// 	this.dayArray = [];
	// 	this.unshiftSelected = false;
	// 	this.days.forEach((day) => {
	// 		this.model[day.value].routeId = null;
	// 	})
	// 	this.loadRoutes('', 0)
	// }

	mappingObjKeyVal(obj) {
		if (obj == null) return obj;
		obj.Key = obj.name + ' (' + obj.branchId + ')';
		obj.Value = obj.id;
		return obj;
	}

	loadRoutes(searchKey, offset) {
		this.total = [];
		this.dayArray = [];
		let selectedBranch = this.model.branch.map((branch) => branch.branchId)
		searchKey = searchKey || '';
		const routeSearchObj = {
			queryJSON: {
				rules: [{
					field: 'branchId',
					condition: 'IN',
					data: selectedBranch
				},
				{
					field: 'holdRoute',
					condition: '=',
					data: false
				},
				{
					field: 'active',
					condition: '=',
					data: true
				},
				{
					group: {
						rules: [{
							field: 'id',
							condition: 'like',
							data: '%' + searchKey + '%'
						},
						{
							field: 'name',
							condition: 'like',
							data: '%' + searchKey + '%'
						}
						],
						operator: 'OR'
					}
				}
				],
				operator: 'AND'
			}
		}

		if (!searchKey && offset !== 0 && Math.abs(offset % 2) == 1 && this.unshiftSelected) {
			offset = offset - 1;
		}
		return this.RouteService.all(routeSearchObj, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				this.currentlyAssignedRoutes = {};

				this.days.forEach((day, index) => {
					let selectedVal = this.model[day.value].routeId ? this.model[day.value].routeId.Value : '';
					if (offset == 0 || offset == undefined) {
						this.total.push({
							[day.value]: {
								total: data.total
							}
						});
						this.dayArray.push({
							[day.value]: this.mapRoutes(data.results, searchKey, selectedVal)
						})
						if (!searchKey && selectedVal && this.unshiftSelected) {
							this.dayArray[index][day.value].unshift(this.model[day.value].routeId);
						}
						// this.obj[day.value] = {};
						if (this.model[day.value].routeId) Object.assign(this.currentlyAssignedRoutes, new Object({ [day.value]: this.model[day.value].routeId.Value }))
						// } else {
						// 	const routeId = this.mapRoutes(data.results, searchKey, selectedVal);
						// 	this.day.routeId = this.day.routeId.concat(routeId);
					}
				});
			});
	}

	loadCustomer(searchKey, offset) {
		searchKey = searchKey || '';
		let costomerSearchObj = this.searchPaginate(searchKey, 'id', 'name');
		if (offset !== 0 && this.model.customer && !searchKey && Math.abs(offset % 2) == 1) {
			offset = offset - 1;
		}
		return this.CustomerService.all(costomerSearchObj, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				let selectedVal = this.model.customer ? this.model.customer.Value : '';
				if (offset === 0 || offset == undefined) {
					this.totalCostomers = data.total;
					this.customer = this.mapArrayData(data.results, searchKey, selectedVal);

					if (!searchKey && selectedVal) {
						this.customer.unshift(this.model.customer);
					}
				} else {
					const customer = this.mapArrayData(data.results, searchKey, selectedVal);
					this.customer = this.customer.concat(customer);
				}
			});
	}

	loadCostCenter(searchKey, offset) {
		searchKey = searchKey || '';

		const obj = {
			queryJSON: {
				rules: [
					{
						field: "customerFlag",
						condition: "=",
						data: false
					},
					{
						group: {
							rules: [
								{
									field: "id",
									condition: "like",
									data: "%" + searchKey + "%"
								},
								{
									field: "name",
									condition: "like",
									data: "%" + searchKey + "%"
								}
							],
							operator: "OR"
						}
					}
				],
				operator: "AND"
			}
		}

		return this.CostCenterService.all(obj, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.totalCostCenter = data.total;
					this.costCenterList = this.costCenterMap(data.results);
				} else {
					const costCenter = this.costCenterMap(data.results);
					this.costCenterList = this.costCenterList.concat(costCenter);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	loadCustomersCostCenter(searchKey, offset) {
		searchKey = searchKey || '';

		const obj = {
			queryJSON: {
				rules: [
					{
						field: "customerFlag",
						condition: "=",
						data: true
					},
					{
						group: {
							rules: [
								{
									field: "id",
									condition: "like",
									data: "%" + searchKey + "%"
								},
								{
									field: "name",
									condition: "like",
									data: "%" + searchKey + "%"
								}
							],
							operator: "OR"
						}
					}
				],
				operator: "AND"
			}
		}

		return this.CostCenterService.all(obj, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.customerCostCenterObj.total = data.total;
					this.customerCostCenterObj.results = this.costCenterMap(data.results);
				} else {
					const costCenter = this.costCenterMap(data.results);
					this.customerCostCenterObj.results = this.customerCostCenterObj.results.concat(costCenter);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	}

	loadLocationZone(searchKey, offset) {
		const selectedBranchIds = Array.isArray(this.model.branch) ? this.model.branch.map((branch) => branch.branchId) : [];
		const locationId = this.$stateParams.id || this.model.id;
		if (!locationId || !selectedBranchIds.length) {
			this.totalLocationZone = 0;
			this.locationZoneList = [];
			return this.$q.resolve();
		}

		const assigned = this.assignedLocationZones || [];
		const assignedIds = assigned.map((z) => z.id);

		return this.Service.getCoveringZones(locationId, selectedBranchIds).then((data) => {
			const byId = {};
			((data && data.results) || []).forEach((z) => { byId[z.id] = { id: z.id, name: z.name, branchId: z.branchId, dayOfWeek: z.dayOfWeek }; });
			assigned.forEach((z) => { if (selectedBranchIds.indexOf(z.branchId) > -1 && !byId[z.id]) byId[z.id] = { id: z.id, name: z.name, branchId: z.branchId, dayOfWeek: z.dayOfWeek }; });

			const candidate = Object.values(byId);
			this.totalLocationZone = candidate.length;
			this.locationZoneList = this.locationZoneMap(candidate);
			this.locationZoneList.forEach((zone) => { if (zone && zone.zoneId != null) zone.ticked = assignedIds.indexOf(zone.zoneId) > -1; });
			this.model.selectedLocationZones = this.locationZoneList.filter((zone) => zone && zone.zoneId != null && zone.ticked);
		});
	}
	
	buildLocationZoneIdsForSave() {
		const selectedBranchIds = Array.isArray(this.model.branch) ? this.model.branch.map((branch) => branch.branchId) : [];
		const hiddenAssigned = (this.assignedLocationZones || [])
			.filter((z) => selectedBranchIds.indexOf(z.branchId) === -1)
			.map((z) => z.id);
		const visibleTicked = (this.locationZoneList || [])
			.filter((z) => z && z.zoneId != null && z.ticked)
			.map((z) => z.zoneId);
		return Array.from(new Set(hiddenAssigned.concat(visibleTicked)));
	}

	loadDaysRoutes(searchKey, offset, index, dayOfData) {
		let selectedBranch = this.model.branch.map((branch) => branch.branchId)
		searchKey = searchKey || '';
		const routeSearchObj = {
			queryJSON: {
				rules: [{
					field: 'branchId',
					condition: 'IN',
					data: selectedBranch
				},
				{
					field: 'holdRoute',
					condition: '=',
					data: false
				},
				{
					field: 'active',
					condition: '=',
					data: true
				},
				{
					group: {
						rules: [{
							field: 'id',
							condition: 'like',
							data: '%' + searchKey + '%'
						},
						{
							field: 'name',
							condition: 'like',
							data: '%' + searchKey + '%'
						}
						],
						operator: 'OR'
					}
				}
				],
				operator: 'AND'
			}
		}
		if (!searchKey && offset !== 0 && Math.abs(offset % 2) == 1) {
			offset = offset - 1;
		}
		return this.RouteService.all(routeSearchObj, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				let routeValue = this.model[dayOfData].routeId ? this.model[dayOfData].routeId.Value : null
				if (offset === 0 || offset == undefined) {
					this.total[index][dayOfData] = {
						total: data.total
					};

					this.dayArray[index][dayOfData] = this.mapRoutes(data.results, searchKey, routeValue);
				} else {

					const newDayData = this.mapRoutes(data.results, searchKey, routeValue);
					this.dayArray[index][dayOfData] = this.dayArray[index][dayOfData].concat(newDayData);
				}
			});
	}

	calculateCoinAmount(recurringLoad, denom) {
		if (recurringLoad.qty) {
			if (denom.faceValue) {
				recurringLoad.amount = recurringLoad.qty * denom.faceValue;
			}
		} else {
			recurringLoad.amount = '';
		}
	}

	calculateAndUpdateDayOccurrences(route) {
		const params = {
			locationId: route.locationId || this.model.id,
			dayOfWeek: route.day.value,
			anchorDate: moment(route.anchorDate).format('YYYY-MM-DD'),
			interval: route.interval.interval,
			frequency: route.interval.frequency || route.frequency,
			sequence: route.sequence,
			branchId: this.model.branchId
		};

		// TODO: only fetch from db if something changes in route
		this.LocationService.calculateDayOccurrences(params.locationId, params.dayOfWeek, params.anchorDate, params.interval, params.frequency, params.sequence, params.branchId)
			.then((data) => {
				this.Modal.nextScheduledOccurences(data);
			}).catch((error) => {
				console.error('Error recalculating occurrences:', error);
			})
	}
	mapRoutes(mapArray, searchKey, originalVal) {
		let newArray = [];
		mapArray.map((obj) => {
			obj.Key = obj.name + ' (' + obj.shortName + ')';
			obj.Value = obj.id;
			newArray.push(obj);
		});
		return newArray;
	}

	searchPaginate(searchKey, idField, nameField) {
		return {
			queryJSON: {
				rules: [{
					field: idField,
					condition: 'like',
					data: '%' + searchKey + '%'
				},
				{
					field: nameField,
					condition: 'like',
					data: '%' + searchKey + '%'
				}
				],
				operator: 'OR'
			}
		}
	}

	customerSearchObj(searchKey) {
		return {
			queryJSON: {
				rules: [
					{
						field: "isEnabled",
						condition: "=",
						data: true
					},
					{
						group: {
							rules: [
								{
									field: "id",
									condition: "like",
									data: "%" + searchKey + "%"
								},
								{
									field: "name",
									condition: "like",
									data: "%" + searchKey + "%"
								}
							],
							operator: "OR"
						}
					}
				],
				operator: "AND"
			}
		}
	}

	loadCustomer(searchKey, offset) {
		searchKey = searchKey || '';
		let costomerSearchObj = this.customerSearchObj(searchKey);
		if (offset !== 0 && this.model.customer && !searchKey && Math.abs(offset % 2) == 1) {
			offset = offset - 1;
		}
		return this.CustomerService.all(costomerSearchObj, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				let selectedVal = this.model.customer ? this.model.customer.Value : '';
				if (offset === 0 || offset == undefined) {
					this.totalCostomers = data.total;
					this.customer = this.mapArrayData(data.results, searchKey, selectedVal);

					if (!searchKey && selectedVal) {
						this.customer.unshift(this.model.customer);
					}
				} else {
					const customer = this.mapArrayData(data.results, searchKey, selectedVal);
					this.customer = this.customer.concat(customer);
				}
			});
	}

	// loadContract(searchKey, offset) {
	// 	searchKey = searchKey || '';
	// 	let contractSearchObj = this.searchPaginate(searchKey, 'contractId', 'contractName');
	// 	if (offset !== 0 && this.model.contract && !searchKey && Math.abs(offset % 2) == 1) {
	// 		offset = offset - 1;
	// 	}
	// 	return this.ContractService.all(contractSearchObj, offset, AppConstants.defaultPageLimit)
	// 		.then((data) => {
	// 			let selectedVal = this.model.contract ? this.model.contract.Value : '';
	// 			if (offset === 0 || offset == undefined) {
	// 				this.totalContracts = data.total;
	// 				this.contracts = this.mapContractsData(data.results, searchKey, selectedVal);
	// 				if (!searchKey && selectedVal) {
	// 					this.contracts.unshift(this.model.contract);
	// 				}
	// 			} else {
	// 				const contracts = this.mapContractsData(data.results, searchKey, selectedVal);
	// 				this.contracts = this.contracts.concat(contracts);
	// 			}
	// 		});
	// }

	mapArrayData(mapArray, searchKey, originalVal) {
		let newArray = [];
		mapArray.map((obj) => {
			obj.Key = obj.id + ' | ' + obj.name;
			obj.Value = obj.id;
			if (!searchKey && originalVal) {
				if (obj.id !== originalVal) {
					newArray.push(obj);
				}
			} else {
				newArray.push(obj);
			}
		});
		return newArray;
	}

	costCenterMap(events) {
		return events.map((data) => {
			return {
				Key: data.id + ' | ' + data.name,
				Value: data.id
			}
		});
	}

	// mapContractsData(mapArray, searchKey, originalVal) {
	// 	let newArray = [];
	// 	mapArray.map((obj) => {
	// 		obj.Key = obj.contractId + ' | ' + obj.contractName;
	// 		obj.Value = obj.id;
	// 		if (!searchKey && originalVal) {
	// 			if (obj.id !== originalVal) {
	// 				newArray.push(obj);
	// 			}
	// 		} else {
	// 			newArray.push(obj);
	// 		}
	// 	});
	// 	return newArray;
	// }

	mapShiptypeArray(mapArray, searchKey, originalVal) {
		let newArray = [];
		mapArray.map((obj) => {
			obj.Key = obj.description;
			obj.Value = obj.id;
			if (!searchKey && originalVal) {
				if (obj.id !== originalVal) {
					newArray.push(obj);
				}
			} else {
				newArray.push(obj);
			}
		});
		return newArray;
	}

	setKeyValue(obj) {
		if (obj == null) return obj;
		obj.Key = obj.id + ' | ' + obj.name;
		obj.Value = obj.id;
		return obj;
	}

	locationZoneMap(records) {
		const DAY_ORDER = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY', 'HOLIDAY'];
		const byBranch = _.groupBy(records || [], 'branchId');

		const grouped = [];
		Object.keys(byBranch).sort().forEach((branchId) => {
			grouped.push({ label: `<strong>${branchId}</strong>`, msGroup: true });
			const byDay = _.groupBy(byBranch[branchId], 'dayOfWeek');
			DAY_ORDER.filter((d) => byDay[d]).forEach((day) => {
				grouped.push({ label: `<strong>${day}</strong>`, msGroup: true });
				byDay[day].forEach((z) => {
					const info = z.id + ' | ' + z.name + ' (' + z.branchId + ', ' + z.dayOfWeek + ')';
					grouped.push({
						Key: info, Value: z.id, zoneId: z.id, zoneInfo: info,
						label: z.id + ' | ' + z.name, ticked: false
					});
				});
				grouped.push({ msGroup: false });
			});
			grouped.push({ msGroup: false });
		});
		return grouped;
	}

	setLocationZoneKeyValue(obj) {
		if (obj == null) return obj;
		const label = obj.id + ' | ' + obj.name + ' (' + obj.branchId + ', ' + obj.dayOfWeek + ')';
		obj.Key = label;
		obj.Value = obj.id;
		obj.zoneId = obj.id;
		obj.zoneInfo = label;
		obj.ticked = true;
		return obj;
	}

	// mappingContractKeyVal(obj) {
	// 	if (obj == null) return obj;
	// 	obj.Key = obj.contractId + ' | ' + obj.contractName,
	// 		obj.Value = obj.id
	// 	return obj
	// }

	loadBranchData() {
		if (!this.model.branch.length) {
			this.days.map((day) => {
				this.model[day.value].routeId = null;
			})
		}
		setTimeout(() => {
			this.loadRoutes('', 0);
			this.routeList('', 0);
			this.loadLocationZone('', 0);
			this.$scope.$digest();
		}, 1000)
	}

	shipTypeSearchObj() {
		const searchObj = {
			queryJSON: {
				rules: [
					{
						field: 'status',
						condition: '=',
						data: true
					},
				],
				operator: 'AND'
			}
		};
		return searchObj.queryJSON.rules.length ? searchObj : null;
	}

	$onInit() {
		this.isValid = true;
		this.isValidMaxLoad = true;
		this.isValidRecurringStops = true;

		this.passwordStats.forEach((stat) => {
			this.passWdIcon[stat] = { viewStaticOpenCode: false };
		});
		this.currentlyAssignedDeliveryToLocation = {};
		var shipTypeSearchObj = this.shipTypeSearchObj();

		this.startMaxDate = {
			minDate: moment().startOf('day').format('YYYY-MM-DD 00:00:00')
		}

		this.$q.all([
			this.UserBranchService.getUserBranches(this.model.loggedInUser),
			this.Service.get(this.$stateParams.id),
			this.LocationDeliveryService.getLocationDeliveryDetails(this.$stateParams.id),
			this.ShiptypeService.all(shipTypeSearchObj, 0, AppConstants.defaultPageLimit),
			this.LocationBranchService.get(this.$stateParams.id),
			// this.Service.getCombinedLocationRecurring(this.$stateParams.id),
			this.loadConfigs(),
			this.getPendingLocationChanges(),
			this.loadPreventativeMaintenances('', 0)
		])
			.then((data) => {
				this.branch = data[0].results;
				data[4].results.forEach((selectedBranch) => {
					this.branch.filter((branch) => {
						if (branch.branchId == selectedBranch.branchId) {
							branch.ticked = true;
						}
					})
				});
				this.defaultModel = data[1];
				this.locationBranches = this.branch.filter(b => b.ticked).map(c => c.branchId);
				this.rawId = data[1].id
				this.model.id = data[1].id
				this.model.name = data[1].name
				this.model.status = data[1].active
				this.model.customer = data[1].customer && data[1].customer.isEnabled ? this.setKeyValue(data[1].customer) : null
				// this.model.contract = this.mappingContractKeyVal(data[1].customerContract)
				this.model.defaultBranch = data[1].branchId || null
				
				const pmId = data[1].preventativeMaintenanceId;
				if (pmId) {
					this.Service.getPreventativeMaintenance(pmId)
						.then(pm => {
							this.model.preventativeMaintenanceId = {
								Key: pm.title + (pm.status === 'Suspended' || pm.status === false ? ' (suspended)' : ''),
								Value: pm.id,
								isSuspended: pm.status === 'Suspended' || pm.status === false
							};
						})
						.catch(err => console.error(err));
				} else {
					this.model.preventativeMaintenanceId = null;
				}
				if (['WINDOW', 'INTERNAL', 'TANKER'].includes(data[1].locationType)) {
					this.model.singleBranch = data[1].branchId || null;
					this.model.branch = this.branch.filter(b => b.ticked);
				}
				this.model._address = data[1].address
				this.model._city = data[1].city
				this.model._state = data[1].state
				this.model._zip = data[1].zip
				this.model.refId = data[1].refNumber
				this.model._poc = data[1].poc
				this.model.pocPhone = data[1].phone || null
				this.model.pocEmail = data[1].email
				this.model.deliverBagOutPiece = data[1].deliverBagOutPiece
				this.model.individualBagout = data[1].individualBagout
				this.model.centralBank = data[1].centralBank
				this.model.RNdeliveries = !!data[1].routeNotificationDeliveries
				this.model.RNpickups = !!data[1].routeNotificationPickups
				this.model.RNnoPickup = !!data[1].routeNotificationNoPickup
				this.model.RNzeroPickup = !!data[1].routeNotificationZeroPickup
				this.model.Mon.routeId = this.mappingObjKeyVal(data[1].defRouteMon);
				this.model.Tue.stops = data[1].defRouteMonStop;
				this.model.Mon.options = data[1].defRouteSeqMon
				this.model.Tue.routeId = this.mappingObjKeyVal(data[1].defRouteTue);
				this.model.Tue.stops = data[1].defRouteTueStop;
				this.model.Tue.options = data[1].defRouteSeqTue
				this.model.Wed.routeId = this.mappingObjKeyVal(data[1].defRouteWed);
				this.model.Wed.stops = data[1].defRouteWedStop;
				this.model.Wed.options = data[1].defRouteSeqWed
				this.model.Thu.routeId = this.mappingObjKeyVal(data[1].defRouteThu);
				this.model.Thu.stops = data[1].defRouteThuStop;
				this.model.Thu.options = data[1].defRouteSeqThu
				this.model.Fri.routeId = this.mappingObjKeyVal(data[1].defRouteFri);
				this.model.Fri.stops = data[1].defRouteFriStop;
				this.model.Fri.options = data[1].defRouteSeqFri
				this.model.Sat.routeId = this.mappingObjKeyVal(data[1].defRouteSat);
				this.model.Sat.stops = data[1].defRouteSatStop;
				this.model.Sat.options = data[1].defRouteSeqSat
				this.model.Sun.routeId = this.mappingObjKeyVal(data[1].defRouteSun);
				this.model.Sun.stops = data[1].defRouteSunStop;
				this.model.Sun.options = data[1].defRouteSeqSun
				this.model.Hol.routeId = this.mappingObjKeyVal(data[1].defRouteHol);
				this.model.Hol.stops = data[1].defRouteHolStop;
				this.model.Hol.options = data[1].defRouteSeqHol
				this.model.seasonStart = data[1].seasonStart ? data[1].seasonStart : null
				this.model.seasonEnd = data[1].seasonEnd ? data[1].seasonEnd : null
				this.effctDate = moment(this.model.seasonStart).format('Y-MM-DD')
				// this.model.deliveryBackoutTimes = data[1].deliveryBackoutTimes
				// this.model.startTime = this.getDate(data[1].openTime)
				// this.model.endTime = this.getDate(data[1].closeTime)
				this.model.deliveryLoc1 = data[1].deliveryLoc1Id
				this.model.deliveryLoc2 = data[1].deliveryLoc2Id
				this.model.deliveryLocCoin = data[1].deliveryLocCoinId
				this.model.deliveryLocCod = data[1].deliveryLocCodId
				this.model._type = data[1].locationType
				this.model.keyId = data[1].keyNum
				this.model.maxDepositAmount = data[1].maxDepositAmount || 0
				this.model.roundedDeposits = data[1].decimalCash
				this.model.codAllow = data[1].codPickup
				this.model.allowMulti = data[1].allowMulti
				this.model.bulkTransfer = !!data[1].bulkTransfer
				this.model._leave = data[1].scanLeaveLocation
				this.model.lastTransaction = data[1].scanLastTransaction
				this.model.verifyToTruck = data[1].verifyToTruck
				this.model.verifyCoinToTruck = data[1].verifyCoinToTruck !== undefined ? data[1].verifyCoinToTruck : false
				this.model.atmCassette = data[1].scanATMCassette
				this.model.maxCassettes = data[1].maxCassettes != null ? data[1].maxCassettes : null
				this.model.packCoinSeparately = !!(data[1].packCoinSeparately)
				this.model.captureDenomStc = !!(data[1].captureDenomStc)
				this.model.TRdeliveries = !data[1].noPrintDelivery
				this.model.TRpickups = !data[1].noPrintPickup
				this.model.latitude = data[1].lat
				this.model.longitude = data[1].long
				// this.model.deliveryBackoutTimes = !!(data[1].openTime || data[1].closeTime)
				this.model.lockType = data[1].lockType || null
				this.model.comments = data[1].comments || null
				this.model.OTCCompanyName = data[1].OTCCompanyName || null
				this.model.stopProcess = data[1].stopProcess || null
				this.model.openTimeSun = this.getNonUTCDate(data[1].openTimeSun)
				this.model.closeTimeSun = this.getNonUTCDate(data[1].closeTimeSun)
				this.model.openTimeMon = this.getNonUTCDate(data[1].openTimeMon)
				this.model.closeTimeMon = this.getNonUTCDate(data[1].closeTimeMon)
				this.model.openTimeTue = this.getNonUTCDate(data[1].openTimeTue)
				this.model.closeTimeTue = this.getNonUTCDate(data[1].closeTimeTue)
				this.model.openTimeWed = this.getNonUTCDate(data[1].openTimeWed)
				this.model.closeTimeWed = this.getNonUTCDate(data[1].closeTimeWed)
				this.model.openTimeThu = this.getNonUTCDate(data[1].openTimeThu)
				this.model.closeTimeThu = this.getNonUTCDate(data[1].closeTimeThu)
				this.model.openTimeFri = this.getNonUTCDate(data[1].openTimeFri)
				this.model.closeTimeFri = this.getNonUTCDate(data[1].closeTimeFri)
				this.model.openTimeSat = this.getNonUTCDate(data[1].openTimeSat)
				this.model.closeTimeSat = this.getNonUTCDate(data[1].closeTimeSat)
				this.model.openTimeHoliday = this.getNonUTCDate(data[1].openTimeHoliday)
				this.model.closeTimeHoliday = this.getNonUTCDate(data[1].closeTimeHoliday)
				this.model.ATMTransfer = data[1].ATMTransfer
				this.model.OTCGeoFence = data[1].OTCGeoFence
				this.model.closeReq = data[1].closeReq
				this.model.closeEndOfStop = !!data[1].closeEndOfStop
				this.model.zoneRouting = data[1].zoneRouting
				this.model.staticOpenCode = data[1].staticOpenCode
				this.currentLocationAddressObj = {
					address: data[1].address,
					city: data[1].city,
					state: data[1].state,
					zip: data[1].zip
				}
				this.model.stopPriority = data[1].stopPriority;
				this.model.model = data[1].model;
				this.model.serialNumber = data[1].serialNumber;
				this.model.secondaryLock = data[1].secondaryLock;
				this.model.secondaryLockId = data[1].secondaryLockId;
				this.model.secondaryLockType = data[1].secondaryLockType;
				this.model.secondaryLockOTCCompanyName = data[1].secondaryLockOTCCompanyName;
				this.model.secondaryLockCloseReq = data[1].secondaryLockCloseReq;
				this.model.secondaryLockAutoOpen = data[1].secondaryLockAutoOpen;
				this.model.secondaryLockStaticOpenCode = data[1].secondaryLockStaticOpenCode;
				this.model.enableOrderProfile = data[1].enableOrderProfile;
				this.model.handleAtmLikeRegular = data[1].handleAtmLikeRegular;
				this.model.idBatchImport = data[1].idBatchImport;
				this.model.idBagoutExport = data[1].idBagoutExport;
				this.model.idBagoutDepositExport = data[1].idBagoutDepositExport;
				this.model.idOTCLock = data[1].idOTCLock;
				this.model.scheduledLocations = data[1].scheduledLocations.length > 0 ? _.cloneDeep(data[1].scheduledLocations) : [];
				this.model.NFCLock = data[1].NFCLock;
				this.model.country = data[1].country;
				this.model.isNonUSLocation = data[1].country !== 'US' ? true : false;
				this.model.NFCScan = data[1].NFCScan;
				this.model.NFCTagId = data[1].NFCTagId;
				this.model.distanceFromBranch = data[1].distanceFromBranch;
				this.model.travelTimeToBranch = data[1].travelTimeToBranch;
				this.model.costCenter = this.setKeyValue(data[1].costCenter);
				this.assignedLocationZones = (data[1].locationZones || []).map(zone => ({ id: zone.id, name: zone.name, branchId: zone.branchId, dayOfWeek: zone.dayOfWeek }));
				this.model.selectedLocationZones = (data[1].locationZones || []).map(zone => this.setLocationZoneKeyValue(zone));
				this.model.customerCostCenter = this.setKeyValue(data[1].customerCostCenter);
				this.model.accountNumber = data[1].accountNumber;
				this.orderProfile = data[1].atmOrderProfile;
				this.model.recurringStops = data[1].locationScheduleRecurringData;
				this.locationScheduleRecurringData = _.cloneDeep(data[1].locationScheduleRecurringData);
				this.loadAtmMakes(data[1].make);
				this.model.machineOwner = data[1].machineOwner;
				this.model.bankSourceId = data[1].bankSource;
				this.model.FLMProvider = data[1].FLMProvider;
				this.model.SLMProvider = data[1].SLMProvider;
				this.model.bankWeek = data[1].bankWeek;
				this.model.frequencyOptions = data[1].frequency;
				this.model.dayOfWeekOptions = data[1].dayOfWeek;
				this.model.optional1 = data[1].optional1;
				this.model.optional2 = data[1].optional2;
				this.model.optional3 = data[1].optional3;
				this.model.locationDistanceId = data[1].locationDistanceId ? data[1].locationDistanceId : null;
				this.model.locationDistance = data[1].locationDistance ? data[1].locationDistance.label : null;
				this.model.contractExpirationDate = data[1].contractExpirationDate ? moment(data[1].contractExpirationDate).format('YYYY-MM-DD') : null;
				this.model.forecastingStrategy = data[1].forecastingStrategy;
				this.model.liabilityThreshold = data[1].liabilityThreshold;
				this.model.securityThreshold = data[1].securityThreshold;
				this.model.atmEmptyAtCalculationMethod = data[1].atmEmptyAtCalculationMethod;
				this.model.aecPercentChangeValue = data[1].aecPercentChangeValue + '%';
				this.model.aecPercentChangePeriodA = data[1].aecPercentChangePeriodA;
				this.model.aecPercentChangePeriodB = data[1].aecPercentChangePeriodB;
				this.model.aecSinglePeriod = data[1].aecSinglePeriod;
				this.model.aecWeightedAvgWeightA = data[1].aecWeightedAvgWeightA;
				this.model.aecWeightedAvgPeriodA = data[1].aecWeightedAvgPeriodA;
				this.model.aecWeightedAvgWeightB = data[1].aecWeightedAvgWeightB;
				this.model.aecWeightedAvgPeriodB = data[1].aecWeightedAvgPeriodB;
				this.model.denominationSourceObj.selectedDenomination = data[1].locationDenomination;
				this.model.locationBalanceActive = data[1].locationBalanceActive ? data[1].locationBalanceActive : [];
				this.model.addToSwapRatio = data[1].addSwapRatio;
				this.model.deliveryCutOff = data[1].deliveryCutOff;
				this.model.deliveryCutOffTime = this.getNonUTCDate(data[1].deliveryCutOffTime);
				this.model.pickupSLA = data[1].pickupSLA;
				this.model.pickupSLATime = data[1].pickupSLATime;
				this.model.lastRouteStop = data[1].lastRouteStop;
				this.model.targetStopTime = this.getNonUTCDate(data[1].targetStopTime);
				this.model.printDeliveryManifest = data[1].printDeliveryManifest;
				this.model.balanceType = data[1].balanceType;
				this.model.forecastingFlowDirection = data[1].forecastingFlowDirection;
				this.model.flowThreshold = data[1].flowThreshold ? data[1].flowThreshold >= 0.1 && data[1].flowThreshold <= 0.9 ? (data[1].flowThreshold * 100).toFixed(3) : data[1].flowThreshold.toFixed(3) : 0.2;
				this.model.podReceipt = data[1].podReceipt;
				this.model.locationSlots = data[1].locationSlots || [];
				this.model.sendManifestOnDelivery = data[1].sendManifestOnDelivery;
				this.model.manifestType = data[1].manifestType;
				this.model.manifestFileType = data[1].manifestFileType;
				this.model.manifestRecipientEmail = data[1].manifestRecipientEmail;
				this.model.zeroAmountPickupRecipientEmail = data[1].zeroAmountPickupRecipientEmail;
				this.model.autoRerouteMissed = data[1].autoRerouteMissed;
				this.model.packResidual = data[1].packResidual;
				this.model.coinPermitted = data[1].coinPermitted;
				this.model.bagoutEnabled = data[1].bagoutEnabled;
				this.model.isTransferHoldLocation = data[1].isTransferHoldLocation;
				this.model.monthlyCashCountLimit = data[1].monthlyCashCountLimit;
				this.model.monthlyCashCountLimitAmount = data[1].monthlyCashCountLimitAmount;
				this.model.fallbackFillRate = data[1].fallbackFillRate === 0 ? 0 : this.toDecimalString(data[1].fallbackFillRate);
				const rawFfr = data[1].fallbackFillRate || 0;
				this.fallbackFillRateDisplay = (rawFfr * 100 * 86400).toFixed(4) + '%';
				this.filterStopProcess();
				// this.model.recurringStops.forEach(recurringStop => {
				// 	recurringStop.anchorDate = recurringStop.anchorDate ? this.DateUtil.convertToDate(recurringStop.anchorDate) : null;
				// 	recurringStop.effectiveTillDate = recurringStop.effectiveTillDate ? this.DateUtil.convertToDate(recurringStop.effectiveTillDate) : null;
				// })

				this.currentlyAssignedBatchImport = {
					idBatchImport: data[1].idBatchImport
				}

				this.currentlyAssignedBagoutExport = {
					idBagoutExport: data[1].idBagoutExport
				}

				this.currentlyAssignedHandleAtmLikeRegular = {
					handleAtmLikeRegular: data[1].handleAtmLikeRegular
				}

				this.currentlyAssignedLocationStatus = {
					active: data[1].active
				}

				this.currentlyAssignedDefaultBranch = {
					branchId: data[1].branchId
				}

				this.currentlyAssignedFundingSource = {
					bankSourceId: data[1].bankSource ? data[1].bankSource.Key : null,
					addSwapRatio: data[1].addSwapRatio || null
				}
				// this.model.deliveryToLocation = this.locationMapping(data[2], data[3], data[3]);

				setTimeout(() => {
					this.$q.all([
						this.loadRoutes('', 0),
						// this.loadContract('', 0),
						[],
						this.loadCustomer('', 0),
						this.Service.all(this.locationSearchObj(), 0, AppConstants.defaultPageLimit),
						this.routeList('', 0),
						this.loadCostCenter('', 0),
						this.loadLocationZone('', 0),
						this.getAllFundingSource('', 0),
						this.loadCustomersCostCenter('', 0),
						this.getAllDenominations('', 0),
						this.getAllLocationSlotDenominations('', 0),
						this.onFlowThresholdBlur('', 0),
						this.loadPickupRequestTimes()
					]).then((res) => {

						// if (data[1].locationDenomination) {
						// 	const denominations = data[1].locationDenomination.map((ele) => ele.denomination);
						// 	this.model.selectedDenomination = this.denominationsDataMap(denominations);

						// 	this.model.selectedDenomination.map((e) => {
						// 		this.model.denominationSourceObj.results.map(i => {
						// 			if (e.id == i.id) {
						// 				i.ticked = true
						// 			}
						// 		})
						// 	})
						// }

						if (data[1].locationDenomination) {
							this.model.selectedDenomination = data[1].locationDenomination.map((item) => {
								if (item.denomination && this.model._type !== 'ATM') {
									item.disableFields = true;
									item.isDisabled = true;
								}
								else {
									item.disableFields = false;
									item.isDisabled = false;
								}

								const balanceActiveItem = data[1].locationBalanceActive.find(
									(balanceItem) =>
										balanceItem.denominationId === item.denomination.id
								);
								return {
									...item,
									locationBalanceActiveId: balanceActiveItem ? balanceActiveItem.id : null,
									isDisabled: true,
									denomination: {
										Key: `${item.denomination.id} | ${item.denomination.name}`,
										Value: item.denomination.id,
										strapCount: item.denomination.strapCount,
										faceValue: item.denomination.faceValue,
										strapCount: item.denomination.strapCount,
										coinFlag: item.denomination.coinFlag
									},
									minResidualThreshold: balanceActiveItem ? Math.round(balanceActiveItem.residualMinimum * 1000000) / 1000000 + '%' : '0%',
									maxResidualThreshold: balanceActiveItem ? Math.round(balanceActiveItem.residualMaximum * 1000000) / 1000000 + '%' : '0%',
									minResidualThresholdPercentage: balanceActiveItem ? Math.round(balanceActiveItem.residualMinimum * 100 * 10000) / 10000 + '%' : '0%',
									maxResidualThresholdPercentage: balanceActiveItem ? Math.round(balanceActiveItem.residualMaximum * 100 * 10000) / 10000 + '%' : '0%',
								};
							});
						}

						this.cloneSelectedDenoms = _.cloneDeep(this.model.selectedDenomination);

						this.DefaultDenominations = this.model.selectedDenomination.map(item => ({
							id: item.denomination.Value,
							Key: item.denomination.Key,//`${item.denomination.id} | ${item.denomination.name}`,
							Value: item.denomination.Value,//item.denomination.id,
							maxLoad: item.maxLoad,
							maxResidualThreshold: this.convertStr(item.maxResidualThreshold),
							minResidualThreshold: this.convertStr(item.minResidualThreshold),
							locationDenominationId: item.id,
							locationBalanceActiveId: item.locationBalanceActiveId,
							denominationStatus: undefined,
							locationBalanceActiveStatus: undefined,
							status: undefined
							// ticked: true 
						}));

						this.getFilteredDenominations();
						this.checkForMaxLoadFaceValueDivisibility();
						// if (this.model.enableOrderProfile && this.orderProfile) {

						// 	this.model.orderProfileObj.selectedOrderProfile = {
						// 		Key: this.orderProfile.branchFundingSourceOrderProfile.name + ' | ' + this.orderProfile.branchFundingSourceOrderProfile.loadInterval,
						// 		Value: this.orderProfile.branchFundingSourceOrderProfile.id
						// 	}

						// 	this.model.fundingSourceObj.selectedFundingSource = {
						// 		Key: this.orderProfile.branchFundingSource.id + ' | ' + this.orderProfile.branchFundingSource.sourceName,
						// 		Value: this.orderProfile.branchFundingSource.id
						// 	}
						// 	this.getOrderProfile('', 0);
						// }

						this.model.deliveryToLocation = this.locationMapping(_.cloneDeep(data[2]), data[3], res[3]);

						this.model.deliveryToLocation.forEach((loc, index) => {
							Object.assign(this.currentlyAssignedDeliveryToLocation, new Object({ [index]: loc.shipTypeDetails.Key.concat(' | ', loc.locationDetails.Key) }))
						});

						this.defaultModel.deliveryToLocation = this.locationMapping(data[2], data[3], res[3]);
						this.defaultModel.locationScheduleRecurringData = data[1].locationScheduleRecurringData ? data[1].locationScheduleRecurringData : [];
						this.defaultModel.scheduledLocations = data[1].scheduledLocations ? data[1].scheduledLocations : [];

						this.renderDirective = true;

						if (this.model.customer) this.changeCustomer();

						this.model.scheduledLocations.map(sl => {
							sl.vaultDate = this.DateUtil.convertToDate(sl.vaultDate)
							sl.routeId = {
								Key: sl.route.name,
								Value: sl.route.id
							};
							sl.status = 'Update';
							sl.scheduleLocationId = sl.id;
						})

						this.scheduledLocations = this.model.scheduledLocations.map(sl => ({
							id: sl.id,
							vaultDate: this.DateUtil.convertToDate(sl.vaultDate),
							routeId: sl.route.id,
							sequence: sl.sequence,
							route: {
								Key: sl.route.name,
								Value: sl.route.id
							},
							locationId: sl.locationId,
							createdAt: sl.createdAt,
							updatedAt: sl.updatedAt
						}))
						this.createCombinedRoutes(this.mappingObjKeyVal(data[1].defRecurringRouteHol));
						this.originalCombinedRoutes = _.cloneDeep(this.combinedRoutes);
						this.createLocationRecurringLoad();
						this.validateLocationSlotsDuplicate();
					})
					this.$scope.$digest();
				})
			})
			.then(() => {
				this.allowStopProcess();
				this.getSetupDetails();
			})
			.finally(() => {
				this.loading = false;
			})
			.catch((err) => {
				console.log(err);
			});

		this.$scope.$watch(() => this.model.coinPermitted, (newVal, oldVal) => {
			if (this.model._type === 'ATM' && this.model.bankSourceId &&
				this.model.denominationSourceObj && this.model.denominationSourceObj.results &&
				this.model.denominationSourceObj.results.length > 0 && newVal !== oldVal) {
				this.getFilteredDenominations();
			}
		});
	}

	locationMapping(deliveryToLocation, shiptypes, locations) {
		if (!deliveryToLocation) return [];
		return deliveryToLocation.map((location, index) => {
			location.disablePickupRequire = false;
			location.shipType = location.shiptypeId;
			location.shipTypeDetails = {
				Key: location.shiptype.description,
				Value: location.shiptypeId
			}
			location.totalShipment = shiptypes.total;
			location.allShipeType = this.mapShiptypeArray(shiptypes.results, '', location.shipTypeDetails.Value);
			location.allShipeType.unshift(location.shipTypeDetails);

			location.location = location.destinationLocationId;
			location.locationDetails = {
				Key: location.destinationLocationId + " | " + location.destinationLocation.name,
				Value: location.destinationLocationId
			}
			location.totalLocation = locations.total;
			location.allLocations = this.mapArrayData(locations.results, '', location.locationDetails.Value);

			location.allLocations.unshift(location.locationDetails);

			location.sortOrder = location.sortOrder || 0;
			location.duplicate = false;
			return location;
		})
	}

	getCenter() {
		const DEFAULT_LATITUDE = -1,
			DEFAULT_LONGITUDE = -1;
		let lat, long;

		lat = this.model.latitude || DEFAULT_LATITUDE;
		long = this.model.longitude || DEFAULT_LONGITUDE;

		return lat && long ? [lat, long] : false;
	}

	createCombinedRoutes(defRecurringRouteHolId) {
		this.combinedRoutes = [];
		this.days.forEach(day => {
			const matchedRoute = _.find(this.locationScheduleRecurringData, { dayOfWeek: day.value });
			var anchorDate
			if (matchedRoute) {
				anchorDate = new Date(matchedRoute.anchorDate);
				anchorDate.setMinutes(anchorDate.getMinutes() + anchorDate.getTimezoneOffset());
			}
			this.combinedRoutes.push({
				combinedRouteIntervals: [...this.combinedRouteIntervals],
				id: matchedRoute ? matchedRoute.id : null,
				frequency: matchedRoute ? matchedRoute.frequency : null,
				sequence: matchedRoute ? matchedRoute.sequence : 99,
				day: day,
				route: day.value === 'Hol' ? defRecurringRouteHolId : matchedRoute ? matchedRoute.route : null,
				interval: matchedRoute ? this.getCombinedRouteInterval(matchedRoute.interval, matchedRoute.frequency) : null,
				anchorDate: matchedRoute ? anchorDate : null,
				isVisible: day.value === 'Hol' ? false : true,
				locationId: matchedRoute ? matchedRoute.locationId : null,
				nextOccurrence: matchedRoute ? matchedRoute.nextOccurrence : null,
				locationScheduleRecurringLoadData: matchedRoute ? matchedRoute.locationScheduleRecurringLoadData : []
			})
		})
	}

	getCombinedRouteInterval(interval, frequency) {
		return this.combinedRouteIntervals.find(ci => ci.interval === interval && ci.frequency === frequency);
	}

	getRouteFromDayArray(index, day, routeId) {
		return this.dayArray[index][day.value].find(d => d.id === routeId)
	}

	changeLocationType() {
		this.model.centralBank = false;
		this.model.verifyToTruck = ['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'BANK', 'DELIVERY'].indexOf(this.model._type) > -1;
		// this.model.verifyCoinToTruck = this.model.verifyToTruck;

		if (this.model._type !== 'ATM') {
			this.model.maxCassettes = null;
		}

		if (this.model._type == 'WINDOW' || this.model._type == 'INTERNAL' || this.model._type == 'TANKER') {
			let anyOne;
			this.branch.forEach((d, index) => {
				if (anyOne == null && d.ticked) {
					anyOne = d;
				} else {
					d.ticked = false;
				}
			});
			// if (anyOne) {
			// 	this.model.singleBranch = anyOne.branchId;
			// 	this.model.branch = this.branch.filter(b => b.ticked);
			// } else {
			// 	this.model.singleBranch = null;
			// 	this.model.branch = [];
			// }
		}
		if (this.model._type !== 'ATM' && this.model._type !== 'LOCKER') {
			this.model.lockType = null;
			this.model.OTCCompanyName = null;
		}

		this.createLocationRecurringLoad();
	}

	onAtmCassetteChange() {
		if (!this.model.atmCassette) {
			this.model.maxCassettes = null;
		}
	}

	onSingleBranchChange() {
		this.branch.forEach(b => {
			b.ticked = (b.branchId === this.model.singleBranch);
		});
		this.model.branch = this.branch.filter(b => b.ticked);
		this.loadBranchData();
	}

	reset() {
		this.$onInit();
		for (let key in this.model) {
			if (key == "today") {
				today: moment().hour(0).minutes(0).second(0).toDate()
			}
		}
		this.resetData();
		this.model.isSameOperationTime = false;
		this.model.sameForAll = false;
		this.currentLocationAddressObj = {};
		this.locationAddressUpdateObj = {};
		this.currentlyAssignedRoutes = {};
		this.updatedAssignedRoutes = {};
		this.currentlyAssignedDeliveryToLocation = {};
		this.updatedDeliveryToLocation = {};
		this.isLocationAddressChanged = false;
		this.isRouteAssignmentChanged = false;
		this.isDeliveryToLocationUpdated = false;
		this.assignedDeliveryLocation = [];
		this.assignedRoutes = [];
		this.model.deletedRecurringStops = [];
		this.locationRecurringLoad = [];
	}

	resetData() {
		if (this.model.startTime && this.model.endTime !== moment().format('hh:mm s')) { } else {
			angular.element("input[type='time']").val(null);
		}
	}

	validateDeleteRecurringStops(selectedRoute) {
		if (selectedRoute.route || selectedRoute.anchorDate || selectedRoute.interval) {
			return true;
		}
		this.deleteCombinedRoute(selectedRoute);
	}

	isDisabledDate = function (currentDate) {
		// if (this.model.seasonStart > this.model.seasonEnd) {
		// 	// this.model.seasonEnd = this.model.seasonStart;
		// 	this.today = moment.utc(currentDate).format();
		// 	this.dateRangeError = 'Start date should be greater than end date';
		// } else {
		// 	this.today = moment.utc().format();
		// 	delete this.dateRangeError;
		// }
		this.todayMinDate = {
			minDate: this.model.seasonStart,
			formatDayTitle: 'MMMM',
			maxMode: "day"
		}
	}

	isUTC() {
		this.x = moment(this.model.seasonEnd).format('Y-MM-DD');
		this.expDate = `${this.x}T23:59:59.000Z`;
		this.model.seasonEnd = this.expDate
	}

	submit(evt) {
		let promise = Promise.resolve();
		this.findLocationAddressChange();
		this.findRouteAssignmentChange();
		// if (!this.validate()) {
		// 	return
		// }
		// this.autoDetect()
		// .then(() => {

		this.loading = true;

		if (this.isLocationAddressChanged || (!this.model.distanceFromBranch && !this.model.travelTimeToBranch) || (!this.model.latitude || !this.model.longitude)) {
			promise = promise.then(() => this.autoDetect());
		}

		this.x = moment(this.model.seasonEnd).format('Y-MM-DD');
		this.expDate = moment(this.model.seasonEnd).format('YYYY-MM-DD');
		this.effDate = moment(this.model.seasonStart).format('YYYY-MM-DD');
		this.checkForMaxLoadFaceValueDivisibility();

		const SavedDenominations = (this.model.selectedDenomination || []).map(item => ({
			id: item.denomination ? item.denomination.id || item.denomination.Value : null,
			Key: item.denomination ? item.denomination.Key || `${item.denomination.Value} | ${item.name}` : null,
			Value: item.denomination ? item.denomination.Value : null,
			maxLoad: item.maxLoad,
			denominationStatus: item.denominationStatus,
			locationBalanceActiveStatus: item.locationBalanceActiveStatus,
			status: item.status,
			maxResidualThreshold: this.convertStr(item.maxResidualThreshold),
			minResidualThreshold: this.convertStr(item.minResidualThreshold),
			locationDenominationId: item.id,
			locationBalanceActiveId: item.locationBalanceActiveId
			// ticked: item.ticked || false
		}));

		if (this.model.deliveryToLocation && this.model.deliveryToLocation.length) {
			this.model.deliveryToLocation.map((deliveryLocObj, index) => {
				delete deliveryLocObj.$$hashKey
				// if (deliveryLocObj.allLocations) {
				// 	delete (this.model.deliveryToLocation[index].allLocations)
				// }
				// if (deliveryLocObj.allShipeType) {
				// 	delete (this.model.deliveryToLocation[index].allShipeType)
				// }
			})
		}

		if (this.model.scheduledLocations.length) {
			this.model.scheduledLocations.forEach((d) => {
				d.vaultDate = moment(d.vaultDate).format('YYYY-MM-DD')
				d.routeId = d.routeId.Value
			})
		}

		const savedScheduledLocations = (this.model.scheduledLocations || []).map(sl => ({
			id: sl.id,
			vaultDate: moment.utc(sl.vaultDate).format('YYYY-MM-DD'),
			routeId: sl.routeId,
			sequence: sl.sequence,
			route: {
				Key: sl.route ? sl.route.name : null,
				Value: sl.route ? sl.route.id : null
			},
			locationId: sl.locationId,
			createdAt: sl.createdAt,
			updatedAt: sl.updatedAt,
		}));

		// if (this.model.recurringStops.length && ['TRUCK', 'INTERNAL', 'TANKER', 'WINDOW', 'CARRIER'].indexOf(this.model._type) === -1) {
		// const recurringStops = [];
		// this.model.recurringStops.forEach((d) => {
		// 	d.anchorDate = moment(d.anchorDate).format('YYYY-MM-DD');
		// 	d.effectiveTillDate = d.effectiveTillDate ? moment(d.effectiveTillDate).format('YYYY-MM-DD') : null;
		// 	d.routeId = d.route.Value;
		// 	d.locationId = this.model.id;
		// 	delete d.route;
		// 	recurringStops.push(_.cloneDeep(d));
		// })

		const combinedRoutes = [];
		this.combinedRoutes.forEach((r) => {
			if (r.route && r.sequence && r.anchorDate && r.interval) {
				combinedRoutes.push({
					id: r.id ? r.id : null,
					description: `${r.day.value} ${r.locationId ? r.locationId : this.model.id} CombinedRoute`,
					anchorDate: moment(r.anchorDate).format('YYYY-MM-DD'),
					interval: r.interval.interval,
					frequency: r.interval.frequency,
					effectiveTillDate: null,
					sequence: r.sequence,
					dayOfWeek: r.day.value,
					locationId: this.model.id,
					routeId: r.route.Value,
					route: r.route,
					nextOccurrence: r.nextOccurrence,
					locationScheduleRecurringLoadData: this.locationRecurringLoad.flatMap(d =>
						d.locationScheduleRecurringDay === r.day.value
							? Object.entries(d.recurringLoad).map(([key, value]) => ({
								id: value.id ? value.id : null,
								amount: value.amount,
								locationScheduleRecurringId: r.id,
								denominationId: key,
								dayOfWeek: r.day.value
							})).sort((a, b) => a.id - b.id) : [])
				})
			}
		});

		// this.locationScheduleRecurringData.forEach(route => {
		// 	recurringStops.forEach(recurringStop => {
		// 		if (!_.isEqual(route, recurringStop) && recurringStop.id) {
		// 			recurringStop.status = 'Update';
		// 		}
		// 		else if (_.isEqual(route, recurringStop) && recurringStop.id) {
		// 			recurringStop.status = null;
		// 		}
		// 	})
		// })
		// }

		var savedData = {
			id: this.model.id,
			updatedAt: this.defaultModel.updatedAt,
			name: this.model.name,
			active: this.model.status,
			customerId: this.model.customer ? this.model.customer.Value : null,
			// customerContractId: this.model.contract ? this.model.contract.Value : null,
			branchId: this.model.defaultBranch,
			address: this.model._address || null,
			city: this.model._city || null,
			state: this.model._state,
			zip: this.model._zip || null,
			refNumber: this.model.refId ? this.model.refId : null,
			poc: this.model._poc || null,
			phone: this.model.pocPhone || null,
			email: this.model.pocEmail || null,
			routeNotificationDeliveries: this.model.RNdeliveries,
			routeNotificationPickups: this.model.RNpickups,
			routeNotificationNoPickup: this.model.RNnoPickup,
			routeNotificationZeroPickup: this.model.RNzeroPickup,
			defRouteMonId: this.model.Mon.routeId ? this.model.Mon.routeId.Value : null,
			// defRouteMonStop: this.model.Tue.stops,
			defRouteSeqMon: this.model.Mon.options || 1,
			defRouteTueId: this.model.Tue.routeId ? this.model.Tue.routeId.Value : null,
			// defRouteTueStop: this.model.Tue.stops,
			defRouteSeqTue: this.model.Tue.options || 1,
			defRouteWedId: this.model.Wed.routeId ? this.model.Wed.routeId.Value : null,
			// defRouteWedStop: this.model.Wed.stops,
			defRouteSeqWed: this.model.Wed.options || 1,
			defRouteThuId: this.model.Thu.routeId ? this.model.Thu.routeId.Value : null,
			// defRouteThuStop: this.model.Thu.stops,
			defRouteSeqThu: this.model.Thu.options || 1,
			defRouteFriId: this.model.Fri.routeId ? this.model.Fri.routeId.Value : null,
			// defRouteFriStop: this.model.Fri.stops,
			defRouteSeqFri: this.model.Fri.options || 1,
			defRouteSatId: this.model.Sat.routeId ? this.model.Sat.routeId.Value : null,
			// defRouteSatStop: this.model.Sat.stops,
			defRouteSeqSat: this.model.Sat.options || 1,
			defRouteSunId: this.model.Sun.routeId ? this.model.Sun.routeId.Value : null,
			// defRouteSunStop: this.model.Sun.stops,
			defRouteSeqSun: this.model.Sun.options || 1,
			defRouteHolId: this.model.Hol.routeId ? this.model.Hol.routeId.Value : null,
			// defRouteHolStop: this.model.Hol.stops,
			defRouteSeqHol: this.model.Hol.options || 1,
			// seasonStart: this.model.seasonStart,
			// seasonEnd: this.model.seasonEnd,
			seasonStart: this.model.seasonStart ? this.effDate : null,
			seasonEnd: this.model.seasonEnd ? this.expDate : null,
			// deliveryBackoutTimes: this.model.deliveryBackoutTimes,
			deliverBagOutPiece: this.model.deliverBagOutPiece,
			individualBagout: this.model.individualBagout,
			centralBank: this.model.centralBank,
			openTime: this.model.startTime ? moment(this.model.startTime).format('HH:mm:ss') : null,
			closeTime: this.model.endTime ? moment(this.model.endTime).format('HH:mm:ss') : null,
			deliveryLoc1Id: this.model.deliveryLoc1 || null,
			deliveryLoc2Id: this.model.deliveryLoc2 || null,
			deliveryLocCoinId: this.model.deliveryLocCoin || null,
			deliveryLocCodId: this.model.deliveryLocCod || null,
			locationType: this.model._type,
			keyNum: this.model.keyId || null,
			maxDepositAmount: this.model.maxDepositAmount,
			decimalCash: this.model.roundedDeposits,
			codPickup: this.model.codAllow,
			allowMulti: this.model.allowMulti,
			scanLeaveLocation: this.model._leave,
			scanLastTransaction: this.model.lastTransaction,
			verifyToTruck: ['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'BANK', 'DELIVERY'].indexOf(this.model._type) > -1 ? this.model.verifyToTruck : false,
			verifyCoinToTruck: ['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO', 'BANK', 'DELIVERY'].indexOf(this.model._type) > -1 && this.model.verifyToTruck ? this.model.verifyCoinToTruck : false,
			scanATMCassette: (this.model._type === 'ATM' ? this.model.atmCassette : false),
			maxCassettes: (this.model._type === 'ATM' && this.model.atmCassette) ? parseInt(this.model.maxCassettes, 10) : null,
			packCoinSeparately: !!this.model.packCoinSeparately,
			captureDenomStc: (this.model._type === 'ATM' ? !!this.model.captureDenomStc : false),
			monthlyCashCountLimit: !!this.model.monthlyCashCountLimit,
			monthlyCashCountLimitAmount: this.model.monthlyCashCountLimitAmount,
			noPrintDelivery: !this.model.TRdeliveries,
			noPrintPickup: !this.model.TRpickups,
			lat: this.model.latitude,
			long: this.model.longitude,
			deliveryToLocation: this.model.deliveryToLocation || [],
			lockType: this.model.lockType,
			comments: this.model.comments || null,
			OTCCompanyName: this.model.OTCCompanyName || null,
			stopProcess: this.model.stopProcess || null,
			openTimeSun: this.model.openTimeSun ? moment(this.model.openTimeSun).format('HH:mm:00') : null,
			closeTimeSun: this.model.closeTimeSun ? moment(this.model.closeTimeSun).format('HH:mm:00') : null,
			openTimeMon: this.model.openTimeMon ? moment(this.model.openTimeMon).format('HH:mm:00') : null,
			closeTimeMon: this.model.closeTimeMon ? moment(this.model.closeTimeMon).format('HH:mm:00') : null,
			openTimeTue: this.model.openTimeTue ? moment(this.model.openTimeTue).format('HH:mm:00') : null,
			closeTimeTue: this.model.closeTimeTue ? moment(this.model.closeTimeTue).format('HH:mm:00') : null,
			openTimeWed: this.model.openTimeWed ? moment(this.model.openTimeWed).format('HH:mm:00') : null,
			closeTimeWed: this.model.closeTimeWed ? moment(this.model.closeTimeWed).format('HH:mm:00') : null,
			openTimeThu: this.model.openTimeThu ? moment(this.model.openTimeThu).format('HH:mm:00') : null,
			closeTimeThu: this.model.closeTimeThu ? moment(this.model.closeTimeThu).format('HH:mm:00') : null,
			openTimeFri: this.model.openTimeFri ? moment(this.model.openTimeFri).format('HH:mm:00') : null,
			closeTimeFri: this.model.closeTimeFri ? moment(this.model.closeTimeFri).format('HH:mm:00') : null,
			openTimeSat: this.model.openTimeSat ? moment(this.model.openTimeSat).format('HH:mm:00') : null,
			closeTimeSat: this.model.closeTimeSat ? moment(this.model.closeTimeSat).format('HH:mm:00') : null,
			openTimeHoliday: this.model.openTimeHoliday ? moment(this.model.openTimeHoliday).format('HH:mm:00') : null,
			closeTimeHoliday: this.model.closeTimeHoliday ? moment(this.model.closeTimeHoliday).format('HH:mm:00') : null,
			ATMTransfer: this.model.ATMTransfer,
			OTCGeoFence: this.model.OTCGeoFence,
			closeReq: this.model.closeReq,
			closeEndOfStop: this.model.stopProcess === 'L' && this.model.closeEndOfStop,
			newLocationAddress: this.newLocationAddress,
			previousLocationAddress: this.previousLocationAddress,
			isLocationAddressChanged: this.isLocationAddressChanged,
			newAssignedRoutes: this.newAssignedRoutes,
			previouslyAssignedRoutes: this.previouslyAssignedRoutes,
			isRouteAssignmentChanged: this.isRouteAssignmentChanged,
			zoneRouting: this.model.zoneRouting,
			stopPriority: ['REGULAR', 'ATM', 'ON_CALL', 'DELIVERY', 'BANK', 'NO_SHIP_NO_GO'].indexOf(this.model._type) > -1 ? this.model.stopPriority : null,
			model: this.model._type === 'ATM' ? this.model.model : null,
			serialNumber: this.model._type === 'ATM' ? this.model.serialNumber : null,
			staticOpenCode: this.model.lockType === 'static' ? this.model.staticOpenCode : null,
			vaultDate: this.DateUtil.getUTCDate(this.model.setupDetails.currentVaultDate),
			userId: this.model.loggedInUser,
			secondaryLock: this.model.secondaryLock,
			secondaryLockId: this.model.secondaryLock ? this.model.secondaryLockId : null,
			secondaryLockType: this.model.secondaryLock ? this.model.secondaryLockType : null,
			secondaryLockOTCCompanyName: this.model.secondaryLock ? this.model.secondaryLockOTCCompanyName : null,
			secondaryLockCloseReq: this.model.secondaryLockType !== 'static' && this.model.secondaryLock ? this.model.secondaryLockCloseReq : false,
			secondaryLockAutoOpen: this.model.secondaryLockType !== 'static' && this.model.secondaryLock ? this.model.secondaryLockAutoOpen : false,
			secondaryLockStaticOpenCode: (this.model.secondaryLock && this.model.secondaryLockType == 'static') ? this.model.secondaryLockStaticOpenCode : null,
			enableOrderProfile: this.model.enableOrderProfile,
			branchFundingSourceId: this.model.enableOrderProfile ? this.model.fundingSourceObj.selectedFundingSource.Value : null,
			branchFundingSourceOrderProfileId: this.model.enableOrderProfile ? this.model.orderProfileObj.selectedOrderProfile.Value : null,
			atmOrderProfileId: this.orderProfile ? this.orderProfile.id : null,
			handleAtmLikeRegular: this.model.handleAtmLikeRegularLocationType.includes(this.model._type) ? this.model.handleAtmLikeRegular : false,
			idBatchImport: this.model.idBatchImport || null,
			idBagoutExport: this.model.idBagoutExport || null,
			idBagoutDepositExport: this.model.idBagoutDepositExport || null,
			idOTCLock: this.model.idOTCLock || null,
			scheduledLocations: this.model.scheduledLocations,
			deleteScheduledLocationIds: this.model.deleteScheduledLocationIds,
			NFCLock: (this.model.lockType === 'witz' || this.model.lockType === 'TDS') ? this.model.NFCLock : false,
			country: this.model.isNonUSLocation ? this.model.country : 'US',
			NFCScan: this.model.NFCScan,
			NFCTagId: this.model.NFCScan ? this.model.NFCTagId : null,
			distanceFromBranch: this.model.distanceFromBranch,
			travelTimeToBranch: this.model.travelTimeToBranch,
			costCenterId: this.model.costCenter ? this.model.costCenter.Value : null,
			locationZoneIds: this.buildLocationZoneIdsForSave(),
			customerCostCenterId: this.model.customerCostCenter ? this.model.customerCostCenter.Value : null,
			accountNumber: this.model.accountNumber ? this.model.accountNumber.trim() : null,
			// recurringStops,
			deletedRecurringStops: this.model.deletedRecurringStops,
			make: this.parseMakeValues(this.model.make),
			machineOwner: this.model.machineOwner,
			bankSourceId: this.model.bankSourceId ? this.model.bankSourceId.Value : null,
			FLMProvider: this.model.FLMProvider,
			SLMProvider: this.model.SLMProvider,
			bankWeek: this.model.bankWeek ? this.model.bankWeek : null,
			optional1: this.model.optional1,
			optional2: this.model.optional2,
			optional3: this.model.optional3,
			frequency: this.model.frequencyOptions,
			dayOfWeek: this.model.dayOfWeekOptions,
			combinedRoutes,
			defRecurringRouteHolId: this.combinedRoutes[7].route ? this.combinedRoutes[7].route.Value : null,
			locationDistanceId: this.model.locationDistanceId ? this.model.locationDistanceId : null,
			contractExpirationDate: this.model.contractExpirationDate ? moment(this.model.contractExpirationDate).format('YYYY-MM-DD') : null,
			// locationDenomination: this.model.selectedDenomination && this.model._type === 'ATM' ? this.model.selectedDenomination : null,
			locationDenomination: SavedDenominations && ['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO'].includes(this.model._type) ? SavedDenominations : [],
			forecastingStrategy: this.model.bankSourceId && this.model.bankSourceId.atmForecasting === true ? this.model.forecastingStrategy : 'DISABLED',
			liabilityThreshold: this.model.bankSourceId && this.model.bankSourceId.atmForecasting === true ? (this.model.liabilityThreshold ? this.model.liabilityThreshold : null) : null,
			securityThreshold: this.model.bankSourceId && this.model.bankSourceId.atmForecasting === true ? (this.model.securityThreshold ? this.model.securityThreshold : null) : null,
			atmEmptyAtCalculationMethod: this.model.atmEmptyAtCalculationMethod ? this.model.atmEmptyAtCalculationMethod : 'PERCENT_CHANGE',
			aecPercentChangeValue: this.model.aecPercentChangeValue ? this.convertStr(this.model.aecPercentChangeValue) : 0.5,
			aecPercentChangePeriodA: this.model.aecPercentChangePeriodA ? this.model.aecPercentChangePeriodA : '30D',
			aecPercentChangePeriodB: this.model.aecPercentChangePeriodB ? this.model.aecPercentChangePeriodB : '15D',
			aecWeightedAvgWeightA: this.model.aecWeightedAvgWeightA ? this.model.aecWeightedAvgWeightA : 0.75,
			aecWeightedAvgPeriodA: this.model.aecWeightedAvgPeriodA ? this.model.aecWeightedAvgPeriodA : '30D',
			aecWeightedAvgWeightB: this.model.aecWeightedAvgWeightB ? this.model.aecWeightedAvgWeightB : 0.35,
			aecWeightedAvgPeriodB: this.model.aecWeightedAvgPeriodB ? this.model.aecWeightedAvgPeriodB : '15D',
			aecSinglePeriod: this.model.aecSinglePeriod ? this.model.aecSinglePeriod : '30D',
			locationBranches: this.branch.filter(b => b.ticked).map(c => c.branchId),
			locationScheduleRecurringData: combinedRoutes,
			locationBalanceActive: this.model.locationBalanceActive,
			addSwapRatio: this.model.addToSwapRatio,
			deletedLocationDenominationIds: this.deletedLocationDenominationIds,
			deliveryCutOff: this.model.deliveryCutOff,
			deliveryCutOffTime: this.model.deliveryCutOff && this.model.deliveryCutOffTime ? moment(this.model.deliveryCutOffTime).format('HH:mm:ss') : null,
			lastRouteStop: this.model._type === 'DELIVERY' ? this.model.lastRouteStop : false,
			targetStopTime: this.model.targetStopTime ? moment(this.model.targetStopTime).format('HH:mm:ss') : null,
			printDeliveryManifest: this.model.printDeliveryManifest,
			balanceType: this.model.balanceType,
			forecastingFlowDirection: this.model.forecastingFlowDirection,
			flowThreshold: this.model.flowThreshold && this.model.balanceType == 'PERCENTAGE' ? this.convertStr(this.model.flowThreshold) / 100 : this.model.flowThreshold,
			podReceipt: this.model.podReceipt,
			locationSlots: this.model.locationSlots,
			sendManifestOnDelivery: this.model.sendManifestOnDelivery ? this.model.sendManifestOnDelivery : false,
			manifestType: this.model.sendManifestOnDelivery ? this.model.manifestType : null,
			manifestRecipientEmail: this.model.sendManifestOnDelivery ? this.model.manifestRecipientEmail : null,
			zeroAmountPickupRecipientEmail: this.model.sendManifestOnDelivery ? this.model.zeroAmountPickupRecipientEmail : null,
			manifestFileType: this.model.sendManifestOnDelivery ? this.model.manifestFileType : null,
			pickupSLA: this.model.pickupSLA,
			pickupSLATime: this.model.pickupSLA ? this.model.pickupSLATime : null,
			autoRerouteMissed: this.model.autoRerouteMissed,
			packResidual: this.model._type === 'ATM' ? this.model.packResidual : false,
			coinPermitted: this.model._type === 'ATM' ? this.model.coinPermitted : false,
			bagoutEnabled: ['BANK', 'DELIVERY'].includes(this.model._type) ? this.model.bagoutEnabled : false,
			bulkTransfer: ['TANKER', 'TRUCK', 'INTERNAL'].includes(this.model._type) ? this.model.bulkTransfer : false,
			isTransferHoldLocation: this.model._type === 'INTERNAL' ? this.model.isTransferHoldLocation : false,
			fallbackFillRate: this.model.fallbackFillRate,
			preventativeMaintenanceId: (['ATM', 'ON_CALL'].includes(this.model._type) && this.model.preventativeMaintenanceId) ? this.model.preventativeMaintenanceId.Value : null,
		}

		const hasDenominationChanges = !_.isEqual(this.DefaultDenominations, SavedDenominations) || this.DefaultDenominations.length !== SavedDenominations.length;
		if (hasDenominationChanges) {// Include changes in `savedData.changedObj`
			savedData.changedObj = {
				...savedData.changedObj,
				locationDenomination: {
					"Old Value": this.DefaultDenominations,
					"Updated Value": SavedDenominations
				},
				...this.findDifferencesWithReturn(this.defaultModel, savedData)
			};
		}
		else {
			savedData.changedObj = {
				...savedData.changedObj,
				...this.findDifferencesWithReturn(this.defaultModel, savedData)
			};
		}

		const hasRecurringDataChanges = !_.isEqual(
			_.sortBy(this.defaultModel.locationScheduleRecurringData, 'id'),
			_.sortBy(savedData.locationScheduleRecurringData, 'id')
		)
			|| this.defaultModel.locationScheduleRecurringData.length !== savedData.locationScheduleRecurringData.length

		if (hasRecurringDataChanges) {
			savedData.changedObj = {
				...savedData.changedObj,
				locationScheduleRecurringData: {
					"Old Value": this.defaultModel.locationScheduleRecurringData,
					"Updated Value": savedData.locationScheduleRecurringData
				},
				...this.findDifferencesWithReturn(this.defaultModel, savedData)
			};
		}
		else {
			savedData.changedObj = {
				...savedData.changedObj,
				...this.findDifferencesWithReturn(this.defaultModel, savedData)
			};
		}


		const hasScheduledLocationchanges = !_.isEqual(
			this.scheduledLocations,
			savedScheduledLocations
		) || this.scheduledLocations.length !== savedScheduledLocations.length;

		if (hasScheduledLocationchanges) {
			savedData.changedObj = {
				...savedData.changedObj,
				scheduledLocations: {
					"Old Value": this.scheduledLocations,
					"Updated Value": savedScheduledLocations
				},
				...this.findDifferencesWithReturn(this.defaultModel, savedData)
			};
		}
		else {
			savedData.changedObj = {
				...savedData.changedObj,
				...this.findDifferencesWithReturn(this.defaultModel, savedData)
			};
		}

		promise = promise.then(() => this.Service.update(this.rawId, savedData))
			.then((data) => {
				this.loading = false;
				window.history.length <= 1 ? this.$state.go('location.all', ({ page: 1 }), { reload: true }) : window.history.go(-1);
			})
			.then(() => {
				this.updateLocationBranch()
			})
			.catch((err) => {
				this.loading = false;

				if (err && err.status === 409) {
					this.Modal.confirm({
						header: 'Warning',
						message: 'This location has been updated by another user since you opened this page. Please reload the page to view the latest changes before saving.',
						type: 'warning',
						buttons: ['common.ok']
					});
					return;
				}

				const errorPath = err && err.data && err.data.errors && err.data.errors[0].path;

				if (errorPath === 'LOCATION.NFCTagId') {
					this.errorMessage = this.$translate.instant('common.unique_nfc_tag_id');
				}
				else if (errorPath === "LOCATION.refNumber") {
					this.errorMessage = this.$translate.instant('location.refNumberUnique');
				}
				else if (err && err.data && err.data.errors) {
					err.data.errors.map((e) => {
						this.errorMessage = e.message + '<br/>'
					})
				}
				else {
					this.errorMessage = (err && err.data && err.data.message) ? err.data.message : err;
				}
				this.Modal.errorModal(this.errorMessage);
			})
		// })
	}

	findDifferencesWithReturn(objA, objB) {
		function compareObjects(obj1, obj2) {
			let diff = {};

			for (let key in obj1) {
				if (obj1.hasOwnProperty(key)) {

					if (['locationDenomination', 'locationScheduleRecurringData', 'scheduledLocations'].includes(key)) {
						continue; // Skip these keys
					}

					if (typeof obj1[key] === 'object' && obj1[key] !== null && obj2[key] !== null) {
						if (Array.isArray(obj1[key])) {
							if (JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])) {
								diff[key] = {
									"Old Value": obj1[key],
									"Updated Value": obj2[key]
								};
							}
						} else if (obj2[key] !== undefined && obj1[key] !== undefined) {
							const nestedDiff = compareObjects(obj1[key], obj2[key]);
							if (Object.keys(nestedDiff).length > 0) {
								diff[key] = nestedDiff;
							}
						}
					} else if (obj1[key] !== obj2[key] && obj2[key] !== undefined && obj1[key] !== undefined) {
						if (key === 'status') {
							diff[key] = {
								"Old Value": obj1[key] ? "Active" : "Suspended",
								"Updated Value": obj2[key] ? "Active" : "Suspended"
							};
						}
						else {
							diff[key] = {
								"Old Value": obj1[key],
								"Updated Value": obj2[key]
							};
						}
					}
				}
			}
			return diff;
		}
		return compareObjects(objA, objB);
	}

	// update branch group for location 
	updateLocationBranch() {
		this.branches = this.model.branch.map((branchObj) => branchObj.branchId)
		this.LocationBranchService.updateLocationBranchGroup({
			locationId: this.model.id,
			branches: this.branches
		})
			.then((res) => {
			})
			.catch((err) => {
				console.log(err)
			});
	}

	askToChange() {
		if (!this.model.status) {
			this.model.status = !this.model.status
			this.Modal.confirm({
				header: this.$translate.instant(`${this.pageName}.suspend_${this.pageName}`),
				message: this.$translate.instant(`${this.pageName}.suspend_${this.pageName}_message`),
				callback: ({
					modal,
					$scope
				}) => {
					this.model.status = !this.model.status
					modal.close()
				},
				negative: ({
					modal,
					$scope
				}) => {
					modal.close()
				},
				type: 'danger',
				buttons: ['common.yes', 'common.no']
			})
		}
	}

	autoDetect() {
		if (!this.render) return Promise.resolve();

		let address = '';

		if (this.model._address) address += this.model._address + ", ";
		if (this.model._city) address += this.model._city + ", ";
		if (this.model._state) address += this.model._state + ", ";
		if (this.model._zip) address += this.model._zip;

		this.model.updatingDrivingDistance = true;
		this.findLocationAddressChange();

		if (['ATM', 'NO_SHIP_NO_GO', 'REGULAR', 'BANK', 'ON_CALL', 'DELIVERY'].indexOf(this.model._type) > -1 &&
			this.maintainDriveDistance && (this.isLocationAddressChanged || !this.model.distanceFromBranch && !this.model.travelTimeToBranch) && this.model.status) {

			return this.Service.getLocationDrivingDistance(address, this.formatAddress(this.model.setupDetails))
				.then((data) => {
					if (data.status) {
						if (_.isEmpty(data.results)) {
							return Promise.reject('location.invalidAddress');
						}
						else if (data.results.status === 'NOT_FOUND') {
							return Promise.reject('location.not_found');
						}
						else if (data.results.status === 'ZERO_RESULTS') {
							return Promise.reject('location.zero_results');
						} else {
							this.model.distanceFromBranch = data.results.distance.text;
							this.model.travelTimeToBranch = data.results.duration.text;
							this.model.locationDistance = data.results.locationDistance ? data.results.locationDistance.label : '';
							this.model.locationDistanceId = data.results.locationDistance ? data.results.locationDistance.id : '';
							return this.locationGeoCodes(address);
						}
					}
					else return Promise.reject(data.errorMessage);
				})
				.catch((err) => {
					// this.Modal.errorModal(err);
					return Promise.reject(err);
				})
				.finally(() => {
					this.model.updatingDrivingDistance = false;
				})
		}
		else {
			this.model.updatingDrivingDistance = false;
			return this.locationGeoCodes(address);
		}
	}

	locationGeoCodes(address) {
		if (!address) return;
		const geocoder = new google.maps.Geocoder();
		const results = geocoder.geocode({ 'address': address });
		if (!results || results.length == 0) return;
		else if (address == '') {
			this.Modal.errorModal('location.invalidAddress');
			this.loading = false;
			return;
		}

		return geocoder.geocode({ 'address': address }, (results, status) => {
			if (status === 'OK') {
				let latitude = results[0].geometry.location.lat();
				let longitude = results[0].geometry.location.lng();
				this.setMarkerPosition(latitude, longitude);
				this.$scope.$apply();
			}
			else if (status === 'NOT_FOUND') {
				this.loading = false;
				this.Modal.errorModal('location.not_found');
			}
			else if (status === 'ZERO_RESULTS') {
				this.loading = false;
				this.Modal.errorModal('location.zero_results');
			}
			else {
				this.Modal.errorModal('location.invalidAddress');
				this.loading = false;
			}
		})
	}

	getAddressFromLatLng(lat, lng) {
		const defer = this.$q.defer();

		if (!lat || !lng) {
			this.loading = false;
			return defer.resolve();
		}

		const geocoder = new google.maps.Geocoder();
		const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };

		geocoder.geocode({ location: latlng }, (results, status) => {
			if (status === 'OK' && results && results.length > 0) {
				const result = results[0];
				const addressComponents = result.address_components;

				let locationData = {
					address: '',
					city: '',
					country: '',
					state: '',
					zip: ''
				};

				for (const component of addressComponents) {
					const types = component.types;
					let locAddress = null;
					if (types.length === 0) locAddress = component.long_name;
					else if (types.includes('street_number')) locAddress = component.short_name;
					else if (types.includes('route')) locAddress = component.long_name;

					if (locAddress) {
						locationData.address = [locationData.address, locAddress].filter(Boolean).join(' ');
					}

					if (types.includes('locality')) {
						locationData.city = component.long_name;
					}
					if (types.includes('country')) {
						locationData.country = component.long_name;
					}
					if (types.includes('administrative_area_level_1')) {
						locationData.state = component.long_name;
					}
					if (types.includes('postal_code')) {
						locationData.zip = component.long_name;
					}
				}
				this.model._address = locationData.address;
				this.model._city = locationData.city;
				this.model.country = locationData.country;
				this.model._zip = locationData.zip;

				if (this.model.isNonUSLocation) {
					this.model._state = locationData.state;
				} else {
					const matchedState = this.states.find(
						state => state.label.toLowerCase() === locationData.state.toLowerCase()
					);
					this.model._state = matchedState ? matchedState.value : '';
				}

				this.loading = false;
				this.$scope.$apply();

				return defer.resolve(locationData);
			}
			else if (status === 'ZERO_RESULTS' || status === 'NOT_FOUND') {
				this.loading = false;
				this.Modal.errorModal('location.not_found');
				return defer.reject('No results found');
			}
			else {
				this.loading = false;
				this.Modal.errorModal('location.invalidAddress');
				return defer.reject('Geocoder failed: ' + status);
			}
		});

		return defer.promise;
	}

	setMarkerPosition(lat, lng) {
		let self = this;
		if (!lat && !lng) {
			var lat = document.getElementById("lat").value;
			var lng = document.getElementById("lng").value;
		}
		else {
			if (lat && lng) {
				this.getAddressFromLatLng(lat, lng)
			}
			document.getElementById("lat").value = lat;
			document.getElementById("lng").value = lng;
			self.model.latitude = document.getElementById("lat").value;
			self.model.longitude = document.getElementById("lng").value;
		}

		var oldMarker;

		var latlng = new google.maps.LatLng(lat, lng);

		var options = { zoom: 16, center: latlng, mapTypeId: google.maps.MapTypeId.ROADMAP }

		var map = new google.maps.Map(document.getElementById("map"), options);

		oldMarker = new google.maps.Marker({ position: latlng, map: map, draggable: true });

		google.maps.event.addListener(oldMarker, "dragend", (event) => {
			var dragLat = event.latLng.lat();
			var dragLng = event.latLng.lng();
			if (dragLat && dragLng) {
				this.getAddressFromLatLng(dragLat, dragLng)
			}
			document.getElementById("lat").value = dragLat;
			document.getElementById("lng").value = dragLng;
			self.model.latitude = dragLat;
			self.model.longitude = dragLng;
			self.$scope.$apply();
		});

		google.maps.event.addListener(map, "click", (event) => {
			// get lat/long of click
			var clickLat = event.latLng.lat();
			var clickLong = event.latLng.lng();
			if (clickLat && clickLong) {
				this.getAddressFromLatLng(clickLat, clickLong)
			}
			// show in input box
			document.getElementById("lat").value = clickLat;
			document.getElementById("lng").value = clickLong;

			self.model.latitude = clickLat;
			self.model.longitude = clickLong;

			var marker = new google.maps.Marker({ position: new google.maps.LatLng(clickLat, clickLong), map: map, draggable: true });

			if (oldMarker != undefined) { oldMarker.setMap(null); }
			oldMarker = marker;

			google.maps.event.addListener(marker, "dragend", (event) => {
				var dragLat = event.latLng.lat();
				var dragLng = event.latLng.lng();
				if (dragLat && dragLng) {
					this.getAddressFromLatLng(dragLat, dragLng)
				}
				document.getElementById("lat").value = dragLat;
				document.getElementById("lng").value = dragLng;
				self.model.latitude = dragLat;
				self.model.longitude = dragLng;
				self.$scope.$apply();
			});
		});

		if (this.maintainDriveDistance) {
			this.marker = new google.maps.Marker({
				position: new google.maps.LatLng(this.model.setupDetails.gpsLat, this.model.setupDetails.gpsLong),
				map: map,
				label: {
					text: 'B',
					color: 'white',
					fontWeight: 'bold',
				}
			});

			const branchInfoPopup = new google.maps.InfoWindow({
				content: `
				<h6>Branch Address</h6>
				<p>${this.model.setupDetails.address}, ${this.model.setupDetails.city}, 
				   ${this.model.setupDetails.state}, ${this.model.setupDetails.zip}</p>
			`
			});

			this.marker.addListener('click', () => {
				branchInfoPopup.open({
					anchor: this.marker,
					map
				});
			});
		}
	}

	branchLocation() {
		const branchLocation = this.model.setupDetails,
			mapElement = document.getElementById('map'),
			locationLatitude = document.getElementById("lat").value,
			locationLongitude = document.getElementById("lng").value;

		var map = new google.maps.Map(mapElement, {
			zoom: 16,
			center: new google.maps.LatLng(locationLatitude, locationLongitude),
			mapTypeId: google.maps.MapTypeId.ROADMAP
		});

		const branchInfoPopup = new google.maps.InfoWindow({
			content: `
				<h6>Branch Address</h6>
				<p>${this.model.setupDetails.address}, ${this.model.setupDetails.city}, 
				   ${this.model.setupDetails.state}, ${this.model.setupDetails.zip}</p>
			`
		});

		new google.maps.Marker({
			position: new google.maps.LatLng(locationLatitude, locationLongitude),
			map,
		});

		this.marker = new google.maps.Marker({
			position: new google.maps.LatLng(branchLocation.gpsLat, branchLocation.gpsLong),
			map,
			label: {
				text: 'B',
				color: 'white',
				fontWeight: 'bold'
			}
		});

		this.marker.addListener('click', () => {
			branchInfoPopup.open({
				anchor: this.marker,
				map
			});
		});
	}

	resetSeason() {
		this.model.seasonStart = null;
		this.model.seasonEnd = null;
	}

	allowStopProcess() {
		this.showStopProcess = ['TANKER', 'TRUCK', 'WINDOW', 'CARRIER', 'LOCKER'].indexOf(this.model._type) === -1;
		if (!this.showStopProcess) this.model.stopProcess = null;
	}

	loadConfigs() {
		this.Configs.getConfigs()
			.then((data) => {
				this.googleMapConfig = data.googleMap;
				this.maintainDriveDistance = data.maintainDriveDistance;
				this.apiKey = '//maps.google.com/maps/api/js?key=' + this.googleMapConfig.key + '&libraries=places'
				setTimeout(() => {
					this.render = true;
				}, 100);
				setTimeout(() => {
					if (this.maintainDriveDistance) this.branchLocation();
				}, 1000)
				return data;
			})
			.then((data) => {
				this.companyMapping(data.otcCompanyList);
			})
			.catch((err) => {
				console.log(err);
			});
	}

	sameOperationTime() {
		this.contractDays = [];
		this.operationDays.forEach((data) => {
			this.contractDays[data.value] = true;
		})

		if (this.model.isSameOperationTime) {
			for (let day in this.contractDays) {
				if (this.contractDays[day]) {
					this.model[this.openTime + day] = ''
					this.model[this.closeTime + day] = ''
				}
			}
		}
	}

	updateTime(selectedDay) {
		if (this.model.isSameOperationTime) {
			if (this.contractDays[selectedDay]) {
				for (let day in this.contractDays) {
					if (this.contractDays[day]) {
						this.model[this.openTime + day] = this.model[this.openTime + selectedDay]
						this.model[this.closeTime + day] = this.model[this.closeTime + selectedDay]
					}
				}
			}
		}
	}

	companyMapping(data) {
		this.OTCCompanyNameList = this.CommonLayoutService.OTCCompanyMapping(data);
	}

	getSetupDetails() {
		if (!this.model.defaultBranch) {
			return this.model.setupDetails = "";
		}
		this.SetupService.get(this.model.defaultBranch)
			.then((data) => {
				this.model.setupDetails = data;
			})
			.catch((err) => {
				console.log(err);
			})
	}

	findLocationAddressChange() {
		this.locationAddressUpdateObj = {
			address: this.model._address,
			city: this.model._city,
			state: this.model._state,
			zip: this.model._zip
		};

		const newLocationAddress = this.findDifference(this.locationAddressUpdateObj, this.currentLocationAddressObj);
		const previousLocationAddress = this.findDifference(this.currentLocationAddressObj, this.locationAddressUpdateObj);
		if (!_.isEmpty(newLocationAddress) && !_.isEmpty(previousLocationAddress)) this.isLocationAddressChanged = true;

		this.newLocationAddress = this.formatLocationAddress(newLocationAddress);
		this.previousLocationAddress = this.formatLocationAddress(previousLocationAddress);
	}

	findDifference(object, base) {
		return _.transform(object, (result, value, key) => {
			if (!_.isEqual(value, base[key])) {
				result[key] = _.isObject(value) && _.isObject(base[key]) ? this.findDifference(value, base[key]) : value;
			}
		});
	}

	formatLocationAddress(obj) {
		let locationAddress = '';
		if (obj.address) {
			locationAddress = locationAddress.concat(locationAddress == '' ? '' : ', ', obj.address);
		}
		if (obj.city) {
			locationAddress = locationAddress.concat(locationAddress == '' ? '' : ', ', obj.city);
		}
		if (obj.state) {
			locationAddress = locationAddress.concat(locationAddress == '' ? '' : ', ', obj.state);
		}
		if (obj.zip) {
			locationAddress = locationAddress.concat(locationAddress == '' ? '' : ', ', obj.zip);
		}
		return locationAddress;
	}

	findRouteAssignmentChange() { // TODO: better solution for this
		this.isRouteAssignmentUpdate = false;
		this.updatedAssignedRoutes = {};
		this.assignedRoutes = [];

		this.days.forEach((day, index) => {
			if (this.model[day.value].routeId) Object.assign(this.updatedAssignedRoutes, new Object({ [day.value]: this.model[day.value].routeId.Value }))
		})

		this.previouslyAssignedRoutes = this.findDifference(this.currentlyAssignedRoutes, this.updatedAssignedRoutes);
		this.newAssignedRoutes = this.findDifference(this.updatedAssignedRoutes, this.currentlyAssignedRoutes);
		this.isRouteAssignmentUpdate = !_.isEmpty(this.previouslyAssignedRoutes) || !_.isEmpty(this.newAssignedRoutes)

		for (let [newKey, newValue] of Object.entries(this.newAssignedRoutes)) {
			if (this.previouslyAssignedRoutes[newKey] === undefined) {
				this.assignedRoutes.push({ key: `defRoute${[newKey]}Id`, value: newValue });
			}
		}

		for (let [oldKey, oldValue] of Object.entries(this.previouslyAssignedRoutes)) {
			if (this.newAssignedRoutes[oldKey] === undefined) {
				this.assignedRoutes.push({ key: `defRoute${[oldKey]}Id`, value: null });
			}
		}

		for (let [oldKey, oldValue] of Object.entries(this.previouslyAssignedRoutes)) {
			for (let [newKey, newValue] of Object.entries(this.newAssignedRoutes)) {
				if ((oldKey === newKey) && (this.previouslyAssignedRoutes[oldKey] != this.newAssignedRoutes[newKey])) {
					this.assignedRoutes.push({ key: `defRoute${[newKey]}Id`, value: newValue });
				}
			}
		}

		for (let [newKey, newValue] of Object.entries(this.newAssignedRoutes)) {
			Object.assign(this.newAssignedRoutes, new Object({ [newKey]: newValue + ' | ' + newKey }))
		}

		for (let [oldKey, oldValue] of Object.entries(this.previouslyAssignedRoutes)) {
			Object.assign(this.previouslyAssignedRoutes, new Object({ [oldKey]: oldValue + ' | ' + oldKey }))
		}
	}

	formatRecurringRouteLabel(route) {
		if (!route || !route.route || !route.sequence || !route.anchorDate || !route.interval) return null;
		const routeName = route.route.Key || route.route.Value;
		const intervalLabel = route.interval.label || `${route.interval.interval}-${route.interval.frequency}`;
		const anchorDate = moment(route.anchorDate).format('DD-MMM-YYYY');
		return `${routeName} | ${intervalLabel} | Seq ${route.sequence} | ${anchorDate} | ${route.day.value}`;
	}

	findRecurringRouteAssignmentChange() {
		this.isRecurringRouteAssignmentUpdate = false;
		this.currentlyAssignedRecurringRoutes = {};
		this.updatedRecurringRoutes = {};
		this.recurringRouteAssignmentUpdatedValues = { rowsToSave: [], idsToDelete: [...(this.model.deletedRecurringStops || [])] };

		const buildMapFromRoutes = (routes) => {
			const map = {};
			(routes || []).forEach((route, index) => {
				if (index > 6) return;
				const label = this.formatRecurringRouteLabel(route);
				if (label) map[route.day.value] = label;
			});
			return map;
		};

		this.currentlyAssignedRecurringRoutes = buildMapFromRoutes(this.originalCombinedRoutes);
		this.updatedRecurringRoutes = buildMapFromRoutes(this.combinedRoutes);

		this.previouslyAssignedRecurringRoutes = this.findDifference(this.currentlyAssignedRecurringRoutes, this.updatedRecurringRoutes);
		this.newAssignedRecurringRoutes = this.findDifference(this.updatedRecurringRoutes, this.currentlyAssignedRecurringRoutes);
		this.isRecurringRouteAssignmentUpdate = !_.isEmpty(this.previouslyAssignedRecurringRoutes) || !_.isEmpty(this.newAssignedRecurringRoutes);

		if (this.isRecurringRouteAssignmentUpdate) {
			const changedDays = new Set([
				...Object.keys(this.previouslyAssignedRecurringRoutes),
				...Object.keys(this.newAssignedRecurringRoutes)
			]);

			(this.combinedRoutes || []).forEach((r, index) => {
				if (index > 6 || !changedDays.has(r.day.value)) return;
				if (r.route && r.sequence && r.anchorDate && r.interval) {
					const dayLoadData = (this.locationRecurringLoad || []).find(d => d.day && d.day.value === r.day.value);
					const locationScheduleRecurringLoadData = dayLoadData && dayLoadData.recurringLoad
						? Object.entries(dayLoadData.recurringLoad)
							.filter(([, value]) => value && value.amount !== undefined && value.amount !== null && value.amount !== '')
							.map(([denominationId, value]) => ({
								id: value.id ? value.id : null,
								amount: value.amount,
								denominationId
							}))
						: [];

					this.recurringRouteAssignmentUpdatedValues.rowsToSave.push({
						id: r.id ? r.id : null,
						description: `${r.day.value} ${r.locationId ? r.locationId : this.model.id} CombinedRoute`,
						anchorDate: moment(r.anchorDate).format('YYYY-MM-DD'),
						interval: r.interval.interval,
						frequency: r.interval.frequency,
						effectiveTillDate: null,
						sequence: r.sequence,
						dayOfWeek: r.day.value,
						locationId: this.model.id,
						routeId: r.route.Value,
						locationScheduleRecurringLoadData
					});
				}
			});
		}
	}

	formatDenominationLabel(denom) {
		if (!denom || !denom.Key) return null;
		return `${denom.Key} | Max Load ${denom.maxLoad != null ? denom.maxLoad : 0} | Min Residual ${denom.minResidualThreshold != null ? denom.minResidualThreshold : 0}% | Max Residual ${denom.maxResidualThreshold != null ? denom.maxResidualThreshold : 0}%`;
	}

	findDenominationChange() {
		this.isDenominationUpdate = false;
		this.currentlyAssignedDenominations = {};
		this.updatedDenominations = {};
		this.denominationUpdatedValues = { rowsToSave: [], deletedLocationDenominationIds: [...(this.deletedLocationDenominationIds || [])] };

		const currentDenominations = (this.model.selectedDenomination || []).map(item => ({
			id: item.denomination ? item.denomination.id || item.denomination.Value : null,
			Key: item.denomination ? item.denomination.Key || `${item.denomination.Value} | ${item.name}` : null,
			Value: item.denomination ? item.denomination.Value : null,
			maxLoad: item.maxLoad,
			denominationStatus: item.denominationStatus,
			locationBalanceActiveStatus: item.locationBalanceActiveStatus,
			status: item.status,
			maxResidualThreshold: this.convertStr(item.maxResidualThreshold),
			minResidualThreshold: this.convertStr(item.minResidualThreshold),
			locationDenominationId: item.id,
			locationBalanceActiveId: item.locationBalanceActiveId
		}));

		const buildMapFromDenominations = (denominations) => {
			const map = {};
			(denominations || []).forEach((denom, index) => {
				const label = this.formatDenominationLabel(denom);
				if (label) map[denom.Value || index] = label;
			});
			return map;
		};

		this.currentlyAssignedDenominations = buildMapFromDenominations(this.DefaultDenominations);
		this.updatedDenominations = buildMapFromDenominations(currentDenominations);

		this.previouslyAssignedDenominations = this.findDifference(this.currentlyAssignedDenominations, this.updatedDenominations);
		this.newAssignedDenominations = this.findDifference(this.updatedDenominations, this.currentlyAssignedDenominations);
		this.isDenominationUpdate = !_.isEmpty(this.previouslyAssignedDenominations) || !_.isEmpty(this.newAssignedDenominations) ||
			!!(this.denominationUpdatedValues.deletedLocationDenominationIds && this.denominationUpdatedValues.deletedLocationDenominationIds.length);

		if (this.isDenominationUpdate) {
			this.denominationUpdatedValues.rowsToSave = currentDenominations;
		}
	}

	formatRecurringLoadLabel(dayValue, denom, loadData) {
		if (!loadData || !denom || !denom.denomination) return null;
		const denomLabel = denom.denomination.Key || denom.denomination.name;
		if (!denomLabel) return null;
		const isCleared = loadData.amount === '' || loadData.amount === null || loadData.amount === undefined;
		const amountDisplay = isCleared ? '-' : loadData.amount;
		return denom.denomination.coinFlag
			? `${dayValue} | ${denomLabel} | Amount ${amountDisplay} | Qty ${loadData.qty}`
			: `${dayValue} | ${denomLabel} | Amount ${amountDisplay}`;
	}

	findScheduleRecurringLoadChange() {
		this.isScheduleRecurringLoadUpdate = false;
		this.currentlyAssignedScheduleRecurringLoad = {};
		this.updatedScheduleRecurringLoad = {};
		this.scheduleRecurringLoadUpdatedValues = { rowsToSave: [] };

		const buildMapFromRecurringLoad = (recurringLoadData) => {
			const map = {};
			(recurringLoadData || []).forEach(dayData => {
				const dayValue = dayData.day ? dayData.day.value : null;
				if (!dayValue) return;
				(dayData.denominations || []).forEach(denom => {
					const denominationId = denom.denomination ? denom.denomination.Value : null;
					if (!denominationId) return;
					const loadData = dayData.recurringLoad ? dayData.recurringLoad[denominationId] : null;
					const label = this.formatRecurringLoadLabel(dayValue, denom, loadData);
					if (label) map[`${dayValue}-${denominationId}`] = label;
				});
			});
			return map;
		};

		this.currentlyAssignedScheduleRecurringLoad = buildMapFromRecurringLoad(this.originalLocationRecurringLoad);
		this.updatedScheduleRecurringLoad = buildMapFromRecurringLoad(this.locationRecurringLoad);

		this.previouslyAssignedScheduleRecurringLoad = this.findDifference(this.currentlyAssignedScheduleRecurringLoad, this.updatedScheduleRecurringLoad);
		this.newAssignedScheduleRecurringLoad = this.findDifference(this.updatedScheduleRecurringLoad, this.currentlyAssignedScheduleRecurringLoad);
		this.isScheduleRecurringLoadUpdate = !_.isEmpty(this.previouslyAssignedScheduleRecurringLoad) || !_.isEmpty(this.newAssignedScheduleRecurringLoad);

		if (this.isScheduleRecurringLoadUpdate) {
			const changedKeys = new Set([
				...Object.keys(this.previouslyAssignedScheduleRecurringLoad),
				...Object.keys(this.newAssignedScheduleRecurringLoad)
			]);

			(this.locationRecurringLoad || []).forEach(dayData => {
				const dayValue = dayData.day ? dayData.day.value : null;
				if (!dayValue) return;
				const matchedRoute = (this.combinedRoutes || []).find(r => r.day && r.day.value === dayValue && r.id);
				if (!matchedRoute) return;

				Object.entries(dayData.recurringLoad || {}).forEach(([denominationId, loadData]) => {
					if (!changedKeys.has(`${dayValue}-${denominationId}`)) return;
					this.scheduleRecurringLoadUpdatedValues.rowsToSave.push({
						id: loadData.id ? loadData.id : null,
						amount: loadData.amount,
						denominationId,
						locationScheduleRecurringId: matchedRoute.id
					});
				});
			});
		}
	}

	saveLater() {
		this.findRouteAssignmentChange();
		this.findDeliveryToLocationChange();
		this.findRecurringRouteAssignmentChange();
		this.findDenominationChange();
		this.findScheduleRecurringLoadChange();
		this.updateLocationStatus();
		this.updateAllBranches();
		this.updateDefaultBranch();
		this.updateFundingSource();
		this.updateBatchImport();
		this.updateBagoutExport();
		this.updateHandleAtmLikeRegular();

		const deliveryToLocation = {
			previouslyAssignedDeliveryToLocation: Object.values(this.previouslyAssignedDeliveryToLocation),
			newAssignedDeliveryToLocation: Object.values(this.newAssignedDeliveryToLocation),
			isDeliveryToLocationUpdated: this.isDeliveryToLocationUpdate,
			updatedValues: this.assignedDeliveryLocation,
			key: 'update_delivery_location'
		}

		const routeAssignment = {
			previouslyAssignedRoutes: Object.values(this.previouslyAssignedRoutes),
			newAssignedRoutes: Object.values(this.newAssignedRoutes),
			isRouteAssignmentChanged: this.isRouteAssignmentUpdate,
			updatedValues: this.assignedRoutes,
			key: 'update_route_assignment'
		}

		const recurringRouteAssignment = {
			previouslyAssignedRecurringRoutes: Object.values(this.previouslyAssignedRecurringRoutes),
			newAssignedRecurringRoutes: Object.values(this.newAssignedRecurringRoutes),
			isRecurringRouteAssignmentChanged: this.isRecurringRouteAssignmentUpdate,
			updatedValues: this.recurringRouteAssignmentUpdatedValues,
			key: 'update_recurring_route_assignment'
		}

		const denomination = {
			previouslyAssignedDenominations: Object.values(this.previouslyAssignedDenominations),
			newAssignedDenominations: Object.values(this.newAssignedDenominations),
			isDenominationChanged: this.isDenominationUpdate,
			updatedValues: this.denominationUpdatedValues,
			key: 'update_denomination'
		}

		const scheduleRecurringLoad = {
			previouslyAssignedScheduleRecurringLoad: Object.values(this.previouslyAssignedScheduleRecurringLoad),
			newAssignedScheduleRecurringLoad: Object.values(this.newAssignedScheduleRecurringLoad),
			isScheduleRecurringLoadChanged: this.isScheduleRecurringLoadUpdate,
			updatedValues: this.scheduleRecurringLoadUpdatedValues,
			key: 'update_schedule_recurring_load'
		}

		const locationStatus = {
			previouslyAssignedLocationStatus: Object.values(this.previouslyAssignedLocationStatus),
			newAssignedLocationStatus: Object.values(this.newAssignedLocationStatus),
			isLocationStatus: this.islocationstatusUpdated,
			updatedValues: this.assignedLocationStatus,
			key: 'update_location_status'
		}

		const allBranches = {
			previouslyAssignedAllBranches: this.locationBranches,
			newAssignedAllBranches: this.currentSelectedBranches,
			isAllBranchesChanged: this.isBranchesUpdated,
			// updatedValues: this.assignedAllBranches,
			key: 'update_all_branches'
		}

		const defaultBranch = {
			previouslyAssignedDefaultBranch: Object.values(this.previouslyAssignedDefaultBranch),
			newAssignedDefaultBranch: Object.values(this.newAssignedDefaultBranch),
			isDefaultBranchChanged: this.isDefaultBranchUpdate,
			updatedValues: this.assignedDefaultBranch,
			key: 'update_default_branch'
		}

		const fundingSource = {
			previouslyAssignedFundingSource: this.previouslyAssignedFundingSource,
			newAssignedFundingSource: this.newAssignedFundingSource,
			isBankSourceChanged: this.isBankSourceUpdate,
			previouslyAssignedSwapRatio: this.previouslyAssignedSwapRatio,
			newAssignedSwapRatio: this.newAssignedSwapRatio,
			isSwapRatioChanged: this.isSwapRatioUpdate,
			isFundingSourceChanged: this.isFundingSourceUpdate,
			updatedValues: this.assignedFundingSource,
			key: 'update_funding_source'
		}

		const batchImport = {
			previouslyAssignedBatchImport: Object.values(this.previouslyAssignedBatchImport),
			newAssignedBatchImport: Object.values(this.newAssignedBatchImport),
			isBatchImportChanged: this.isBatchImportUpdate,
			updatedValues: this.assignedBatchImport,
			key: 'update_batch_import_location'
		}

		const bagoutExport = {
			previouslyAssignedBagoutExport: Object.values(this.previouslyAssignedBagoutExport),
			newAssignedBagoutExport: Object.values(this.newAssignedBagoutExport),
			isBagoutExportChanged: this.isBagoutExportUpdate,
			updatedValues: this.assignedBagoutExport,
			key: 'update_bagout_export_location'
		}

		const routeLikeRegular = {
			previouslyAssignedHandleAtmLikeRegular: Object.values(this.previouslyAssignedHandleAtmLikeRegular),
			newAssignedHandleAtmLikeRegular: Object.values(this.newAssignedHandleAtmLikeRegular),
			isHandleAtmLikeRegular: this.isHandleAtmLikeRegularUpdate,
			updatedValues: this.assignedHandleAtmLikeRegular,
			key: 'update_route_like_regular'
		}

		const extraDetails = {
			id: this.rawId,
			branchId: this.model.defaultBranch,
			name: this.model.name,
			locationType: this.model._type,
			userId: this.model.loggedInUser,
			username: this.User.getUser().firstName.concat(' ', this.User.getUser().lastName)
		}

		this.Modal.saveLocationLaterModal(routeAssignment, deliveryToLocation, this.rawId, locationStatus, allBranches, defaultBranch, batchImport, bagoutExport, routeLikeRegular, recurringRouteAssignment, denomination, scheduleRecurringLoad, fundingSource, ({ modal, duration, dateTime }) => {
			routeAssignment.executeAt = routeAssignment.isRouteAssignmentChanged ? dateTime : null;
			deliveryToLocation.executeAt = deliveryToLocation.isDeliveryToLocationUpdated ? dateTime : null;
			locationStatus.executeAt = locationStatus.isLocationStatus ? dateTime : null;
			allBranches.executeAt = allBranches.isAllBranchesChanged ? dateTime : null;
			defaultBranch.executeAt = defaultBranch.isDefaultBranchChanged ? dateTime : null;
			batchImport.executeAt = batchImport.isBatchImportChanged ? dateTime : null;
			bagoutExport.executeAt = bagoutExport.isBagoutExportChanged ? dateTime : null;
			routeLikeRegular.executeAt = routeLikeRegular.isHandleAtmLikeRegular ? dateTime : null;
			recurringRouteAssignment.executeAt = recurringRouteAssignment.isRecurringRouteAssignmentChanged ? dateTime : null;
			denomination.executeAt = denomination.isDenominationChanged ? dateTime : null;
			scheduleRecurringLoad.executeAt = scheduleRecurringLoad.isScheduleRecurringLoadChanged ? dateTime : null;
			fundingSource.executeAt = fundingSource.isFundingSourceChanged ? dateTime : null;

			const routeDetailsObj = routeAssignment.isRouteAssignmentChanged ? routeAssignment : {};
			const deliveryToLocationObj = deliveryToLocation.isDeliveryToLocationUpdated ? deliveryToLocation : {};
			const locationStatusObj = locationStatus.isLocationStatus ? locationStatus : {};
			const allBranchesObj = allBranches.isAllBranchesChanged ? allBranches : {};
			const defaultBranchObj = defaultBranch.isDefaultBranchChanged ? defaultBranch : {};
			const batchImportObj = batchImport.isBatchImportChanged ? batchImport : {};
			const bagoutExportObj = bagoutExport.isBagoutExportChanged ? bagoutExport : {};
			const routeLikeRegularObj = routeLikeRegular.isHandleAtmLikeRegular ? routeLikeRegular : {};
			const recurringRouteAssignmentObj = recurringRouteAssignment.isRecurringRouteAssignmentChanged ? recurringRouteAssignment : {};
			const denominationObj = denomination.isDenominationChanged ? denomination : {};
			const scheduleRecurringLoadObj = scheduleRecurringLoad.isScheduleRecurringLoadChanged ? scheduleRecurringLoad : {};
			const fundingSourceObj = fundingSource.isFundingSourceChanged ? fundingSource : {};

			this.Service.saveLocationChanges(extraDetails, routeDetailsObj, deliveryToLocationObj, duration, locationStatusObj, allBranchesObj, defaultBranchObj,
				batchImportObj, bagoutExportObj, routeLikeRegularObj, recurringRouteAssignmentObj, denominationObj, scheduleRecurringLoadObj, fundingSourceObj)
				.then(() => window.history.go(-1))
				.catch(err => {
					console.log(err);
					this.Modal.errorModal(err.data.message);
				})
		}, ({ modal }) => {
			if (modal) modal.close();
		});
	}

	findDeliveryToLocationChange() {
		this.isDeliveryToLocationUpdate = false;
		this.updatedDeliveryToLocation = {};
		this.assignedDeliveryLocation = [];

		this.model.deliveryToLocation.forEach((loc, index) => {
			Object.assign(this.updatedDeliveryToLocation, new Object({ [index]: loc.shipTypeDetails.Key.concat(' | ', loc.locationDetails.Key) }));
			this.assignedDeliveryLocation.push({
				locationId: loc.locationDetails.Value, shiptypeId: loc.shipTypeDetails.Value,
				sortOrder: loc.sortOrder, coinFlag: loc.shipTypeDetails.coinFlag
			});
		})

		this.previouslyAssignedDeliveryToLocation = this.findDifference(this.currentlyAssignedDeliveryToLocation, this.updatedDeliveryToLocation)
		this.newAssignedDeliveryToLocation = this.findDifference(this.updatedDeliveryToLocation, this.currentlyAssignedDeliveryToLocation)
		this.isDeliveryToLocationUpdate = !_.isEmpty(this.previouslyAssignedDeliveryToLocation) || !_.isEmpty(this.newAssignedDeliveryToLocation)

		if (this.assignedDeliveryLocation.length && this.pendingLocationChanges && this.pendingLocationChanges.results && this.pendingLocationChanges.results.pendingChanges.length) {
			var uniqueRecords = this.model.locationToBeUpdated
				.filter(item1 => !this.assignedDeliveryLocation
					.some(item2 => (item2.locationId === item1.locationId && item2.shiptypeId === item1.shiptypeId)))

			this.assignedDeliveryLocation = [...uniqueRecords, ...this.assignedDeliveryLocation];
			this.assignedDeliveryLocation.forEach((assignedLoc, index) => {
				assignedLoc.sortOrder = index + 1;
			})
		}
	}

	updateLocationStatus() {
		this.islocationstatusUpdated = false;
		this.assignedLocationStatus = [];
		this.updatedLocationStatus = {
			active: this.model.status,
		};

		const previouslyAssignedLocationStatus = this.findDifference(this.currentlyAssignedLocationStatus, this.updatedLocationStatus);
		const newAssignedLocationStatus = this.findDifference(this.updatedLocationStatus, this.currentlyAssignedLocationStatus);
		this.islocationstatusUpdated = !_.isEmpty(previouslyAssignedLocationStatus) || !_.isEmpty(newAssignedLocationStatus)

		this.previouslyAssignedLocationStatus = previouslyAssignedLocationStatus;
		this.newAssignedLocationStatus = newAssignedLocationStatus;

		for (const [key, value] of Object.entries(this.updatedLocationStatus)) {
			this.assignedLocationStatus.push(key, value);
		}
	}

	updateAllBranches() {
		this.isBranchesUpdated = false;
		this.currentSelectedBranches = this.model.branch.map((branchObj) => branchObj.branchId);
		this.isBranchesUpdated = !_.isEqual(this.locationBranches, this.currentSelectedBranches);
	}

	updateDefaultBranch() {
		this.isDefaultBranchUpdate = false;
		this.assignedDefaultBranch = [];
		this.updatedDefaultBranch = {
			branchId: this.model.defaultBranch
		};

		const previouslyAssignedDefaultBranch = this.findDifference(this.currentlyAssignedDefaultBranch, this.updatedDefaultBranch);
		const newAssignedDefaultBranch = this.findDifference(this.updatedDefaultBranch, this.currentlyAssignedDefaultBranch);
		this.isDefaultBranchUpdate = !_.isEmpty(previouslyAssignedDefaultBranch) || !_.isEmpty(newAssignedDefaultBranch)

		this.previouslyAssignedDefaultBranch = previouslyAssignedDefaultBranch;
		this.newAssignedDefaultBranch = newAssignedDefaultBranch;

		for (const [key, value] of Object.entries(this.updatedDefaultBranch)) {
			this.assignedDefaultBranch.push(key, value);
		}
	}

	formatSwapRatioLabel(value) {
		if (!value) return null;
		const option = this.addToSwapRatioOptions.find((opt) => opt.value === value);
		return option ? option.label : value;
	}

	updateFundingSource() {
		this.isFundingSourceUpdate = false;
		this.assignedFundingSource = [];
		this.updatedFundingSource = {
			bankSourceId: this.model.bankSourceId ? this.model.bankSourceId.Key : null,
			addSwapRatio: this.model.addToSwapRatio || null
		};

		const previouslyAssignedFundingSource = this.findDifference(this.currentlyAssignedFundingSource, this.updatedFundingSource);
		const newAssignedFundingSource = this.findDifference(this.updatedFundingSource, this.currentlyAssignedFundingSource);
		// isFundingSourceUpdate covers the whole section (used to gate the backend save and the shared
		// date/time picker) - Add: Swap Ratio is still persisted together with bankSourceId in one update,
		// since it's derived from the funding source selection, but each is shown as its own row below.
		this.isFundingSourceUpdate = !_.isEmpty(previouslyAssignedFundingSource) || !_.isEmpty(newAssignedFundingSource)

		this.previouslyAssignedFundingSource = [previouslyAssignedFundingSource.bankSourceId].filter((value) => value !== null && value !== undefined);
		this.newAssignedFundingSource = [newAssignedFundingSource.bankSourceId].filter((value) => value !== null && value !== undefined);
		this.isBankSourceUpdate = !!(this.previouslyAssignedFundingSource.length || this.newAssignedFundingSource.length);

		this.previouslyAssignedSwapRatio = [this.formatSwapRatioLabel(previouslyAssignedFundingSource.addSwapRatio)].filter((value) => value !== null && value !== undefined);
		this.newAssignedSwapRatio = [this.formatSwapRatioLabel(newAssignedFundingSource.addSwapRatio)].filter((value) => value !== null && value !== undefined);
		this.isSwapRatioUpdate = !!(this.previouslyAssignedSwapRatio.length || this.newAssignedSwapRatio.length);

		const fundingSourceValues = {
			bankSourceId: this.model.bankSourceId ? this.model.bankSourceId.Value : null,
			addSwapRatio: this.model.addToSwapRatio || null
		};

		for (const [key, value] of Object.entries(fundingSourceValues)) {
			this.assignedFundingSource.push(key, value);
		}
	}

	updateBatchImport() {
		this.isBatchImportUpdate = false;
		this.assignedBatchImport = [];
		this.updatedBatchImport = {
			idBatchImport: this.model.idBatchImport || null,
		};

		const previouslyAssignedBatchImport = this.findDifference(this.currentlyAssignedBatchImport, this.updatedBatchImport);
		const newAssignedBatchImport = this.findDifference(this.updatedBatchImport, this.currentlyAssignedBatchImport);
		this.isBatchImportUpdate = !_.isEmpty(previouslyAssignedBatchImport) || !_.isEmpty(newAssignedBatchImport)

		this.previouslyAssignedBatchImport = previouslyAssignedBatchImport;
		this.newAssignedBatchImport = newAssignedBatchImport;

		for (const [key, value] of Object.entries(this.updatedBatchImport)) {
			this.assignedBatchImport.push(key, value);
		}
	}

	updateBagoutExport() {
		this.isBagoutExportUpdate = false;
		this.assignedBagoutExport = [];
		this.updatedBagoutExport = {
			idBagoutExport: this.model.idBagoutExport || null,
		};

		const previouslyAssignedBagoutExport = this.findDifference(this.currentlyAssignedBagoutExport, this.updatedBagoutExport);
		const newAssignedBagoutExport = this.findDifference(this.updatedBagoutExport, this.currentlyAssignedBagoutExport);

		this.isBagoutExportUpdate = !_.isEmpty(previouslyAssignedBagoutExport) || !_.isEmpty(newAssignedBagoutExport)

		this.previouslyAssignedBagoutExport = previouslyAssignedBagoutExport;
		this.newAssignedBagoutExport = newAssignedBagoutExport;

		for (const [key, value] of Object.entries(this.updatedBagoutExport)) {
			this.assignedBagoutExport.push(key, value);
		}
	}

	updateHandleAtmLikeRegular() {
		this.isHandleAtmLikeRegularUpdate = false;
		this.assignedHandleAtmLikeRegular = [];
		this.updatedHandleAtmLikeRegular = {
			handleAtmLikeRegular: this.model.handleAtmLikeRegular,
		};

		const previouslyAssignedHandleAtmLikeRegular = this.findDifference(this.currentlyAssignedHandleAtmLikeRegular, this.updatedHandleAtmLikeRegular);
		const newAssignedHandleAtmLikeRegular = this.findDifference(this.updatedHandleAtmLikeRegular, this.currentlyAssignedHandleAtmLikeRegular);
		this.isHandleAtmLikeRegularUpdate = !_.isEmpty(previouslyAssignedHandleAtmLikeRegular) || !_.isEmpty(newAssignedHandleAtmLikeRegular)

		this.previouslyAssignedHandleAtmLikeRegular = previouslyAssignedHandleAtmLikeRegular;
		this.newAssignedHandleAtmLikeRegular = newAssignedHandleAtmLikeRegular;

		for (const [key, value] of Object.entries(this.updatedHandleAtmLikeRegular)) {
			this.assignedHandleAtmLikeRegular.push(key, value);
		}
	}

	loadPreventativeMaintenances(searchKey, offset) {
		searchKey = searchKey || '';
		return this.Service.getPreventativeMaintenanceList(10, offset, searchKey)
			.then((data) => {
				const pmList = (data.results || []).map(pm => ({
					Key: pm.title + (pm.status === 'Suspended' ? ' (suspended)' : ''),
					Value: pm.id,
					isSuspended: pm.status === 'Suspended'
				}));
				if (offset === 0 || offset === undefined) {
					this.totalPMRecords = data.total || 0;
					this.pmSearchList = pmList;
				} else {
					this.pmSearchList = this.pmSearchList.concat(pmList);
				}
			});
	}

	getPendingLocationChanges() {
		const deliveryLocations = [];
		this.pendingStopsChangesObj.loading = true;
		return this.Service.getPendingLocationChanges(this.$stateParams.id)
			.then((data) => {
				this.pendingLocationChanges = data;
				this.pendingStopsChangesObj.results = data.results.scheduleStops;
				this.pendingStopsChangesObj.total = data.results.scheduleStops.length;
				data.results.pendingChanges.forEach(pendingChanges => {
					if (pendingChanges.updatedValues && pendingChanges.updatedValues.length) {
						pendingChanges.updatedValues.forEach((updatedRecord) => {
							deliveryLocations.push(updatedRecord);
						})
					}
				})
				this.model.locationToBeUpdated = deliveryLocations;
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				this.pendingStopsChangesObj.loading = false;
			})
	}

	translateMessage(key) {
		if (!key) return;
		return this.$translate.instant('location.' + key);
	}

	confirmDeleteAllPendingChanges() {
		this.Modal.confirm({
			header: this.$translate.instant('common.confirm_delete_title'),
			message: this.$translate.instant('common.confirm_delete_message'),
			callback: (({
				modal,
				$scope
			}) => {
				this.removeAllPendingLocationChanges();
				modal.close();
			}),
			negative: (({
				modal,
			}) => {
				modal.close();
			}),
			type: 'danger'
		})
	}

	cancelScheduledStops(jobKey, event) {
		this.model.deleteStopRecurring = true;
		this.Modal.confirm({
			header: this.$translate.instant('errorModal.title'),
			message: this.$translate.instant(`verifyHoldShipments.forceCloseShipments`),
			callback: (({
				modal
			}) => {
				this.StopSchedulingService.cancelScheduledStops(jobKey)
					.then(() => {
						this.getPendingLocationChanges();
						event.preventDefault();
					})
					.catch((err) => {
						if (err && err.data && err.data.message) {
							this.Modal.errorModal(err.data.message);
						}
					})
					.finally(() => {
						this.model.deleteStopRecurring = false;
					})
				modal.close();
			}),
			buttons: ['common.ok', 'common.cancel'],
			type: 'danger'
		})
	}

	removeLocationChanges(jobId) {
		return this.Service.removeLocationChanges(jobId)
			.then(() => {
				this.getPendingLocationChanges();
			})
			.catch((err) => {
				console.log(err);
				if (err && err.data && err.data.message) {
					this.Modal.errorModal(err.data.message);
				}
			})
	}

	removeAllPendingLocationChanges() {
		const jobIds = _.uniq((this.pendingLocationChanges.results.pendingChanges || []).map((history) => history.jobId));

		return this.$q.all(jobIds.map((jobId) => this.Service.removeLocationChanges(jobId)))
			.then(() => {
				this.getPendingLocationChanges();
			})
			.catch((err) => {
				console.log(err);
				if (err && err.data && err.data.message) {
					this.Modal.errorModal(err.data.message);
				}
			})
	}

	showPassword(stat, type) {
		this.passWdIcon[stat][type] = !this.passWdIcon[stat][type];
	}

	resetOTCCompany() {
		if (this.model.lockType === 'static') this.model.OTCCompanyName = null;
		if (this.model.secondaryLockType === 'static') this.model.secondaryLockOTCCompanyName = null;
	}


	fundingSourceSearchObj(searchKey) {
		searchKey = searchKey || '';
		const selectedBranch = this.model.branch.map((branch) => branch.branchId)

		const obj = {
			queryJSON: {
				rules: [
					{
						field: "branchId",
						condition: "=",
						data: this.model.defaultBranch ? this.model.defaultBranch : selectedBranch
					},
					{
						group: {
							rules: [
								{
									field: "id",
									condition: "like",
									data: "%" + searchKey + "%"
								},
								{
									field: "sourceName",
									condition: "like",
									data: "%" + searchKey + "%"
								}
							],
							operator: "OR"
						}
					}
				],
				operator: "AND"
			}
		}
		return obj.queryJSON.rules.length ? obj : null;
	}

	getAllFundingSource(searchKey, offset) {
		this.model.fundingSourceObj.loading = true;
		const searchObj = this.fundingSourceSearchObj(searchKey);

		return this.BranchFundingSourceService.all(searchObj, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.model.fundingSourceObj.totalRecords = data.total;
					this.model.fundingSourceObj.results = this.fundingSourceDataMap(data.results);
				}
				else {
					const fundingSource = this.fundingSourceDataMap(data.results);
					this.model.fundingSourceObj.results = (this.model.fundingSourceObj.results || []).concat(fundingSource);
				}
			})
			.catch((err) => {
				this.Modal.errorModal(err.data.message);
			})
			.finally(() => {
				this.model.fundingSourceObj.loading = false;
			})
	}

	fundingSourceDataMap(list) {
		return list.map((bfs) => {
			return {
				Key: bfs.id + ' | ' + bfs.sourceName,
				Value: bfs.id,
				atmForecasting: bfs.atmForecasting,
				enforceStraps: bfs.enforceStraps,
			}
		})
	}

	orderProfileSearchObj(searchKey) {
		if (!this.model.fundingSourceObj.selectedFundingSource) return;
		searchKey = searchKey || '';
		const obj = {
			queryJSON: {
				rules: [
					{
						field: "branchFundingSourceId",
						condition: "=",
						data: this.model.fundingSourceObj.selectedFundingSource.Value
					},
					{
						group: {
							rules: [
								{
									field: "name",
									condition: "like",
									data: "%" + searchKey + "%"
								},
								{
									field: "loadInterval",
									condition: "like",
									data: "%" + searchKey + "%"
								}
							],
							operator: "OR"
						}
					}
				],
				operator: "AND"
			}
		}
		return obj.queryJSON.rules.length ? obj : null;
	}

	getOrderProfile(searchKey, offset) {
		this.model.orderProfileObj.loading = true;
		const searchObj = this.orderProfileSearchObj(searchKey);

		this.BranchFundingSourceOrderProfileService.all(searchObj, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.model.orderProfileObj.totalRecords = data.total;
					this.model.orderProfileObj.results = this.orderProfileDataMap(data.results);
				}
				else {
					const fundingSource = this.orderProfileDataMap(data.results);
					this.model.orderProfileObj.results = (this.model.orderProfileObj.results || []).concat(fundingSource);
				}
			})
			.catch((err) => {
				this.Modal.errorModal(err.data.message);
			})
			.finally(() => {
				this.model.orderProfileObj.loading = false;
			})
	}

	orderProfileDataMap(list) {
		return list.map((op) => {
			return {
				Key: op.name + ' | ' + op.loadInterval,
				Value: op.id
			}
		})
	}

	resetDataOnBranchChange() {
		if (this.model.enableOrderProfile) {
			this.model.fundingSourceObj.selectedFundingSource = null;
			this.model.orderProfileObj.selectedOrderProfile = null;
		}
		this.model.bankSourceId = null;
	}

	createLocationScheduled() {
		if (this.model.scheduledLocations.length <= 0) this.routeList('', 0);

		this.minVaultDate = {
			minDate: this.model.setupDetails.currentVaultDate
		}
		this.model.scheduledLocations.push({
			vaultDate: null,
			routeId: null,
			sequence: 99,
			status: 'Create',
			scheduleLocationId: null
		})
	}

	routeList(searchKey, offset) {
		searchKey = searchKey || '';

		const selectedBranch = this.model.branch.map((branch) => branch.branchId)
		const searchObj = {
			queryJSON: {
				rules: [{
					field: 'branchId',
					condition: 'IN',
					data: selectedBranch
				},
				{
					field: 'holdRoute',
					condition: '=',
					data: false
				},
				{
					field: 'active',
					condition: '=',
					data: true
				},
				{
					group: {
						rules: [{
							field: 'id',
							condition: 'like',
							data: '%' + searchKey + '%'
						},
						{
							field: 'name',
							condition: 'like',
							data: '%' + searchKey + '%'
						}
						],
						operator: 'OR'
					}
				}
				],
				operator: 'AND'
			}
		}

		this.model.routeListObj.loading = true;
		return this.RouteService.all(searchObj, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.model.routeListObj.totalRecords = data.total;
					this.model.routeListObj.results = this.mapData(data.results);
				} else {
					const routes = this.mapData(data.results);
					this.model.routeListObj.results = this.model.routeListObj.results.concat(routes);
				}
			})
			.catch((err) => {
				if (err && err.data && err.data.message) {
					Modal.errorModal(err.data.message);
				}
			})
			.finally(() => {
				this.model.routeListObj.loading = false;
			})
	}

	mapData(routes) {
		return routes.map((route) => {
			return {
				Key: route.name,
				Value: route.id
			}
		});
	}

	deleteScheduledLocation(index) {
		this.model.deleteScheduledLocationIds.push(this.model.scheduledLocations[index].scheduleLocationId);
		this.model.scheduledLocations.splice(index, 1);
		this.validateScheduledLocation();
	}

	validateScheduledLocation() {
		this.model.scheduledLocations = _.map(this.model.scheduledLocations, (obj, index) => {
			obj.isDuplicate = false;
			let match = _.find(this.model.scheduledLocations, (compairObject, compairObjIndex) => {
				if (index > compairObjIndex) return new Date(compairObject.vaultDate).getDate() == new Date(obj.vaultDate).getDate();
			});
			if (match) {
				obj.isDuplicate = true;
				return obj;
			} else {
				return obj;
			}
		});
		let isValid = this.model.scheduledLocations.map((obj) => {
			if (obj.isDuplicate) return true;
		})
		this.isValid = isValid.indexOf(true) >= 0 ? false : true;
	}

	resetText() {
		this.model._state = null;
		this.model.country = null;
	}

	parseMakeValues(makeValue) {
		if (Array.isArray(makeValue)) {
			return makeValue
				.map((item) => {
					if (!item) return null;
					if (typeof item === 'string') return item.trim();
					// handle {Key, Value} from isteven-multi-select output-model
					return (item.Value || item.value || item.Key || item.label || item.vendorName || '').trim();
				})
				.filter(Boolean);
		}

		if (!makeValue) return [];

		return String(makeValue)
			.split(',')
			.map((item) => item.trim())
			.filter(Boolean);
	}

	serializeMakeValues(makeValue) {
		const values = this.parseMakeValues(makeValue);
		return values.length ? values.join(', ') : null;
	}

	buildAtmMakeOptions(results, selectedMakes) {
		const selectedValues = this.parseMakeValues(selectedMakes);
		const options = (results || [])
			.filter((item) => item.active)
			.map((item) => ({
				Key: item.vendorName,
				Value: item.vendorName,
				ticked: selectedValues.includes(item.vendorName)
			}));

		return options;
	}

	loadAtmMakes(selectedMakes = this.model.make) {
		return this.AtmMakesService.all('', 0, 1000, true)
			.then(({ results }) => {
				this.atmMakesList = this.buildAtmMakeOptions(results, selectedMakes);
				this.model.make = this.parseMakeValues(selectedMakes);
			})
			.catch((err) => {
				console.log(err);
				this.atmMakesList = [];
				this.model.make = [];
			});
	}

	capitalizeFirstLetter(value) {
		if (typeof value !== 'string') return;
		else return value.charAt(0).toUpperCase() + value.slice(1);
	}

	splitKey(key) {
		if (!key) return;
		return key.split(' | ')[1];
	}

	formatAddress(data) {
		let locationAddress = '';
		if (data.address) locationAddress = locationAddress.concat(data.address, ', ');
		if (data.city) locationAddress = locationAddress.concat(data.city, ', ');
		if (data.state) locationAddress = locationAddress.concat(data.state, ', ');
		if (data.zip) locationAddress = locationAddress.concat(data.zip);
		return locationAddress;
	}

	filterStopProcess() {
		if (this.model.stopProcess !== 'L') this.model.closeEndOfStop = false;
		if (!this.model._type) return;

		const typeMap = {
			ATM: ['L', 'A'],
			ON_CALL: ['D', 'B'],
			REGULAR: ['D'],
			NO_SHIP_NO_GO: ['D'],
			BANK: ['D'],
			DELIVERY: ['D'],
			INTERNAL: ['D']
		};

		const allowed = typeMap[this.model._type];
		const list = this.CommonLayoutService.stopProcessList();
		this.stopProcessList = allowed ? list.filter(({ value }) => allowed.includes(value)) : list;
		if (allowed && !allowed.includes(this.model.stopProcess)) {
			this.model.stopProcess = null;
		}
	}

	createLocationRecurring() {
		if (this.model.recurringStops.length <= 0) this.routeList('', 0);

		this.model.recurringStops.push({
			description: null,
			route: null,
			sequence: 99,
			status: 'Create',
			anchorDate: null,
			effectiveTillDate: null,
			interval: null,
			frequency: 99
		});
	}

	deleteRecurringLocation(index) {
		this.model.deletedRecurringStops.push(this.model.recurringStops[index].id);
		this.model.recurringStops.splice(index, 1);
		this.validateRecurringLocation();
	}

	validateRecurringLocation() {
		this.model.recurringStops = _.map(this.model.recurringStops, (obj, index) => {
			obj.isDuplicate = false;
			let match = _.find(this.model.recurringStops, (compairObject, compairObjIndex) => {
				if (index > compairObjIndex) {
					return new Date(compairObject.anchorDate).getDate() == new Date(obj.anchorDate).getDate() &&
						(compairObject.route && obj.route ? compairObject.route.Value == obj.route.Value : true) && compairObject.interval == obj.interval
				}
			});
			if (match) {
				obj.isDuplicate = true;
				return obj;
			} else {
				return obj;
			}
		});

		let isValid = this.model.recurringStops.map((obj) => {
			if (obj.isDuplicate) return true;
		})

		this.isValidRecurringStops = isValid.indexOf(true) >= 0 ? false : true;
	}

	validateReccuringEndDate(obj) {
		obj.minEndDate = {
			minDate: moment(obj.anchorDate)
		}
		if (obj.effectiveTillDate && obj.anchorDate > obj.effectiveTillDate) {
			obj.effectiveTillDate = moment(obj.anchorDate)
		}
	}

	disableDays(currentDate, mode, enableDay) {
		if (enableDay.value === "Hol") return false;
		return mode === 'day' && (currentDate.getDay() !== this.dayMap[enableDay.value]);
	};

	recheckMonthlyOccurences(anchorDate, day, index) {
		if (!anchorDate) return;
		const selectedDate = new Date(anchorDate);
		const month = selectedDate.getMonth() + 1;
		const year = selectedDate.getFullYear();
		let occurrences = this.countOccurrencesInMonth(year, month, this.dayMap[day.value]);

		switch (occurrences) {
			case 2:
				this.combinedRoutes[index].combinedRouteIntervals = [...this.combinedRouteIntervals].slice(0, -3);
				break;
			case 3:
				this.combinedRoutes[index].combinedRouteIntervals = [...this.combinedRouteIntervals].slice(0, -2);
				break;
			case 4:
				this.combinedRoutes[index].combinedRouteIntervals = [...this.combinedRouteIntervals].slice(0, -1);
				break;
			default:
				this.combinedRoutes[index].combinedRouteIntervals = [...this.combinedRouteIntervals];
				break;
		}
		if (this.combinedRoutes[index].interval && this.combinedRoutes[index].interval.interval === "MONTHOC" && this.combinedRoutes[index].interval.frequency > occurrences) {
			this.combinedRoutes[index].interval = null;
		}
	}

	countOccurrencesInMonth(year, month, targetDay) {
		let count = 0;
		const startDate = new Date(year, month - 1, 1);
		const endDate = new Date(year, month, 0);

		for (let currentDate = startDate; currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 1)) {
			if (currentDate.getDay() === targetDay) {
				count++;
			}
		}

		return count;
	}

	showNextScheduledOccurences(data) {
		this.calculateAndUpdateDayOccurrences(data)
		//this.Modal.nextScheduledOccurences(data);
	}

	deleteCombinedRoute(selectedRoute) {
		this.combinedRoutes = this.combinedRoutes.map(route => {
			if (route.id === selectedRoute.id) {
				return {
					...route,
					id: null,
					anchorDate: null,
					frequency: null,
					sequence: 99, // Default sequence value as a placeholder
					route: null,
					interval: null,
					locationId: null,
					nextOccurrence: null,
				};
			}
			return route;
		});

		this.model.deletedRecurringStops.push(selectedRoute.id);

		this.locationRecurringLoad = this.locationRecurringLoad.map(data => {
			if (selectedRoute.day.value === data.day.value) {
				return {
					day: data.day,
					denominations: data.denominations,
					recurringLoad: {},
					hasLocationScheduleRecurring: false
				}
			};
			return data;
		});

		this.validateRouteAssignment();
		this.checkForStrapCount();
	}

	denominationsSearchObj(searchKey) {
		searchKey = searchKey || '';

		const obj = {
			queryJSON: {
				rules: [
					{
						group: {
							rules: [
								{
									field: "id",
									condition: "like",
									data: "%" + searchKey + "%"
								},
								{
									field: "name",
									condition: "like",
									data: "%" + searchKey + "%"
								}
							],
							operator: "OR"
						}
					},
					// {
					// 	field: "coinFlag",
					// 	condition: "=",
					// 	data: 0
					// }
				],
				operator: "AND"
			}
		};
		return obj.queryJSON.rules.length ? obj : null;
	}

	getAllDenominations(searchKey, offset) {
		if (!this.model.bankSourceId) return;

		this.model.denominationSourceObj.loading = true;
		// const searchObj = this.denominationsSearchObj(searchKey);

		return this.OrderViewService.getFundingSourceDenominationUnpack(this.model.bankSourceId.Value)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.model.denominationSourceObj.totalRecords = data.results.length;
					this.model.denominationSourceObj.results = this.denominationsDataMap(data.results);
				}
				else {
					const denominations = this.denominationsDataMap(data.results);
					this.model.denominationSourceObj.results = this.model.denominations.concat(denominations);
				}
			})
			.catch((err) => {
				this.Modal.errorModal(err.data.message);
			})
			.finally(() => {
				this.model.denominationSourceObj.loading = false;
			})
	}

	getAllLocationSlotDenominations(searchKey, offset) {
		return this.DenominationService.all(searchKey, offset, 1000)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.model.locationSlotDenominations.totalRecords = data.results.length;
					this.model.locationSlotDenominations.results = this.denominationsDataMap(data.results);
				}
				else {
					const denominations = this.denominationsDataMap(data.results);
					this.model.locationSlotDenominations.results = this.model.denominations.concat(denominations);
				}
			})
			.catch((err) => {
				this.Modal.errorModal(err.data.message);
			})
	}

	getFilteredDenominations() {
		setTimeout(() => {
			this.filteredDenominations = {
				results: [],
				totalRecords: 0,
			};

			this.deletedLocationDenominationIds = [];

			if (this.model._type === 'ATM') {
				this.filteredDenominations.results = this.model.denominationSourceObj.results.filter(denom => {
					// Include cash (non-coin) denominations
					if (!denom.coinFlag) {
						return true;
					}
					// Include coin if: location has coinPermitted AND coin is multiDenomPackable AND packaging is loose/rolled
					if (denom.coinFlag && this.model.coinPermitted && denom.multiDenomPackable &&
						denom.coinPackaging && ['INDIVIDUAL', 'ROLLED'].includes(denom.coinPackaging)) {
						return true;
					}
					return false;
				});
				this.filteredDenominations.totalRecords = this.filteredDenominations.results.length;
			}
			else {
				this.filteredDenominations.results = this.model.denominationSourceObj.results;
				this.filteredDenominations.totalRecords = this.filteredDenominations.results.length;
			}

			if (this.model.locationSlots) {
				this.model.locationSlots = this.model.locationSlots.map(slot => {
					if (slot.denominationId) {
						const matchingDenom = this.model.locationSlotDenominations.results.find(d => d.id === slot.denominationId);
						if (matchingDenom) {
							slot.denominationId = matchingDenom;
						}
					}
					return slot;
				});
			}

			this.model.selectedDenomination = this.cloneSelectedDenoms.filter(itemB =>
				this.filteredDenominations.results.some(itemA => itemA.id === itemB.denominationId)
			);

			this.deletedLocationDenominationIds = this.cloneSelectedDenoms
				.filter(itemB =>
					!this.filteredDenominations.results.some(itemA => itemA.id === itemB.denominationId)
				)
				.map(item => ({
					locationDenominationId: item.id,
					locationBalanceActiveId: item.locationBalanceActiveId
				}));
			this.createLocationRecurringLoad();
		}, 500);
	};

	getLocationDenoms(searchKey, offset) {
		if (!this.model.bankSourceId) return;
		this.getAllDenominations(searchKey, offset).then(() => this.getFilteredDenominations());
	}

	denominationsDataMap(list) {
		return list.map((denom) => {
			return {
				id: denom.id,
				Key: denom.id + ' | ' + denom.name,
				Value: denom.id,
				strapCount: denom.strapCount,
				faceValue: denom.faceValue,
				coinFlag: denom.coinFlag,
				shiptypeId: denom.shiptypeId,
				multiDenomPackable: denom.multiDenomPackable,
				coinPackaging: denom.coinPackaging
			}
		})
	}

	isFormInvalid(form) {
		for (let i = 0; i < form.$$controls.length; i++) {
			let field = form.$$controls[i];
			if (field.$$attr.ngModel !== '$ctrl.model.contractExpirationDate' && field.$invalid) {
				return true;
			}
		}
		return false;
	};

	createLocationRecurringLoad() {
		if (['ATM', 'REGULAR', 'ON_CALL', 'NO_SHIP_NO_GO'].indexOf(this.model._type) === -1) {
			this.locationRecurringLoad = [];
			return;
		}

		setTimeout(() => {
			this.days.forEach(day => {
				this.locationRecurringLoad.push({
					day: day,
					denominations: this.model.selectedDenomination,
					recurringLoad: {}
				})
			});

			const routeScheduleMap = new Map();

			this.combinedRoutes.forEach(route => {
				route.locationScheduleRecurringLoadData.forEach(lsr => {
					const key = `${route.day.value}-${lsr.denominationId}`;
					routeScheduleMap.set(key, { amount: lsr.amount, id: lsr.id });
				});
			});

			this.locationRecurringLoad.forEach(data => {
				this.model.selectedDenomination.forEach(denom => {
					const key = `${data.day.value}-${denom.denominationId}`;
					if (routeScheduleMap.has(key)) {
						if (denom.denomination.coinFlag) {
							data.recurringLoad[denom.denominationId] = { amount: routeScheduleMap.get(key).amount, id: routeScheduleMap.get(key).id, qty: routeScheduleMap.get(key).amount / denom.denomination.faceValue };
						} else {
							data.recurringLoad[denom.denominationId] = { amount: routeScheduleMap.get(key).amount, id: routeScheduleMap.get(key).id };
						}
					}
				});
			});

			const uniqueDayMap = new Map();

			for (let i = 0; i < this.locationRecurringLoad.length; i++) {
				const item = this.locationRecurringLoad[i];
				const dayValue = item.day.value;

				if (!uniqueDayMap.has(dayValue)) {
					uniqueDayMap.set(dayValue, { ...item, denominations: [...item.denominations] });
				} else {
					const existingItem = uniqueDayMap.get(dayValue);
					const existingDenominationIds = new Set(existingItem.denominations.map(denom => denom.id));
					const uniqueDenominations = item.denominations.filter(denom => !existingDenominationIds.has(denom.id));
					existingItem.denominations.push(...uniqueDenominations);

					if (Object.keys(existingItem.recurringLoad).length === 0 && Object.keys(item.recurringLoad).length > 0) {
						existingItem.recurringLoad = item.recurringLoad;
					}
				}
			}

			this.locationRecurringLoad = Array.from(uniqueDayMap.values());

			this.locationRecurringLoad.forEach(item => {
				item.denominations = this.model.selectedDenomination.filter(denom => denom.denomination && denom.denomination.Value); //Filter denominations to include only those with denominationId 
				const newDenomination = this.model.selectedDenomination.filter(denom => denom.isNew && denom.denomination); // Add new denominations (if any)
				// if (newDenomination.length >0) item.denominations.push(...newDenomination); 
				if (newDenomination.length > 0) {
					// Use a Set for uniqueness
					const uniqueDenominationsSet = new Set(item.denominations.map(denom => denom.denomination.Value));
					newDenomination.forEach(newDenom => {
						if (!uniqueDenominationsSet.has(newDenom.denomination && newDenom.denomination.Value)) {
							item.denominations.push(newDenom);
							uniqueDenominationsSet.add(newDenom.denomination && newDenom.denomination.Value);
						}
					});
				}

				const validDenominationIds = new Set(this.model.selectedDenomination.map((denom) => denom.denomination ? denom.denomination.Value : null));
				Object.keys(item.recurringLoad).forEach(key => { if (!validDenominationIds.has(key)) delete item.recurringLoad[key] });
			});

			this.validateRouteAssignment();
			this.checkForStrapCount();

			if (!this.recurringLoadSnapshotTaken) {
				this.originalLocationRecurringLoad = _.cloneDeep(this.locationRecurringLoad);
				this.recurringLoadSnapshotTaken = true;
			}

			this.$scope.$apply();
		}, 100);
	}

	checkDenomKeyExists() {
		let isValid = this.model.selectedDenomination.map(d => {
			return !d.denomination || 'isEmpty'
		}).indexOf('isEmpty') !== -1
		return isValid;
	}

	checkForStrapCount() {
		for (let i = 0; i < this.locationRecurringLoad.length; ++i) {
			for (let j = 0; j < this.locationRecurringLoad[i].denominations.length; ++j) {
				const denomination = this.locationRecurringLoad[i].denominations[j];
				const recurringLoad = this.locationRecurringLoad[i]['recurringLoad'];

				if (denomination.denomination && denomination.denomination.strapCount && recurringLoad && recurringLoad[denomination.denomination.Value] && !denomination.denomination.coinFlag) {
					const loadAmount = recurringLoad[denomination.denomination.Value].amount;
					const faceValue = denomination.denomination.faceValue;

					if (loadAmount !== undefined && loadAmount !== null && loadAmount !== '' &&
						(loadAmount / faceValue) % denomination.denomination.strapCount !== 0 && this.model.bankSourceId.enforceStraps == true) {
						recurringLoad[denomination.denomination.Value].isValid = false;
					} else if (loadAmount !== undefined && loadAmount !== null && loadAmount !== '' && loadAmount % faceValue !== 0) {
						recurringLoad[denomination.denomination.Value].isValid = false;
					}
					else {
						recurringLoad[denomination.denomination.Value].isValid = true;
					}
				}
				else if (recurringLoad && recurringLoad[denomination.denomination.Value] && denomination.denomination.coinFlag) {
					recurringLoad[denomination.denomination.Value].isValid = true;
				}
			}
		}
		this.isValidRecurringLoad = this.checkRecurringLoadValidity(this.locationRecurringLoad);
	}

	checkForMaxLoadFaceValueDivisibility() {
		this.isValidMaxLoad = true;
		if (!this.model.selectedDenomination || !this.model.selectedDenomination.length) {
			return true;
		}

		function isValidAmount(amount, faceValue) {
			if (!isFinite(amount) || !isFinite(faceValue) || faceValue <= 0 || amount <= 0) {
				return false;
			}
			const quotient = amount / faceValue;
			const epsilon = 1e-9;
			return Math.abs(quotient - Math.round(quotient)) < epsilon;
		}

		this.model.selectedDenomination.forEach((denomObj) => {
			denomObj.isMaxLoadValid = true;

			const denomination = denomObj.denomination;
			const faceValueRaw = denomination && denomination.faceValue;
			const maxLoadRaw = denomObj.maxLoad;

			if (!denomination || faceValueRaw === undefined || faceValueRaw === null || maxLoadRaw === undefined || maxLoadRaw === null || maxLoadRaw === '') {
				return;
			}

			const faceValue = Number(String(faceValueRaw).replace(/,/g, ''));
			const maxLoad = Number(String(maxLoadRaw).replace(/,/g, ''));

			if (!isFinite(faceValue) || faceValue === 0 || !isFinite(maxLoad)) {
				denomObj.isMaxLoadValid = false;
				return;
			}

			denomObj.isMaxLoadValid = isValidAmount(maxLoad, faceValue);
		});

		this.isValidMaxLoad = this.model.selectedDenomination.every((denomObj) => {
			if (!denomObj.denomination) return true;
			return denomObj.isMaxLoadValid !== false;
		});

		return this.isValidMaxLoad;
	}

	isValidTargetStopTime() {
		if (!this.model.targetStopTime) return true;
		return this.model.targetStopTime.getHours() > 0 || this.model.targetStopTime.getMinutes() > 0;
	}

	validateRouteAssignment() {
		this.totalRouteAssignment = 0;

		const routeMap = new Map();
		this.combinedRoutes.forEach((route) => {
			if (route.route && route.sequence && route.anchorDate && route.interval) {
				routeMap.set(route.day.value, route);
			}
		});

		this.locationRecurringLoad.forEach((location) => {
			const route = routeMap.get(location.day.value);

			if (route) {
				this.totalRouteAssignment++;
				location.locationScheduleRecurringDay = route.day.value;
				location.hasLocationScheduleRecurring = true;
			} else {
				location.hasLocationScheduleRecurring = false;
				location.recurringLoad = {};
			}
		});
	}

	checkRecurringLoadValidity(data) {
		let isValidFlag = true;
		for (let item of data) {
			if (item.recurringLoad) {
				for (let key in item.recurringLoad) {
					const isValid = item.recurringLoad[key].isValid;
					if (!isValid) return false;
					if (isValid) isValidFlag = true;
				}
			}
		}
		return isValidFlag;
	}

	convertStr(str) {
		if (!str) return;
		return Number(str.replace('%', ''));
	}

	ngPercentage() {
		if (this.model.aecPercentChangeValue && !String(this.model.aecPercentChangeValue).endsWith('%')) {
			return this.model.aecPercentChangeValue = this.model.aecPercentChangeValue + '%';
		}
	}

	removePercentageSign() {
		if (this.model.aecPercentChangeValue && this.model.aecPercentChangeValue.endsWith('%')) {
			return this.model.aecPercentChangeValue = this.model.aecPercentChangeValue.replace('%', '');
		}
	}

	onDenominationReset() {
		this.model.selectedDenomination = [];
		this.model.denominationSourceObj.results.forEach((ele) => {
			ele.ticked = false;
		});
		setTimeout(() => {
			this.model.denominationSourceObj.selectedDenomination.forEach((item) => {
				this.model.denominationSourceObj.results.forEach((ele) => {
					if (item.denominationId === ele.value) {
						ele.ticked = true;
						this.model.selectedDenomination.push({
							id: ele.value,
							label: ele.label,
							value: ele.value
						})
					}
				});
			});
			this.$scope.$apply()
		}, 100)

	}

	getLocationLogs(id) {
		this.Modal.locationLogs(id, ({ modal }) => { },
			({ modal }) => {
				if (modal) modal.close();
			})
	}

	createLocationDenomination() {
		// if(this.model.selectedDenomination.length <= 0) this.getAllDenominations('', 0);

		// this.model.selectedDenomination.push({
		// 	denomination: null,
		// 	maxLoad: this.model._type === 'ATM' ? null : 0,
		// 	minResidualThreshold: this.model._type === 'ATM' ? null : 0,
		// 	maxResidualThreshold: this.model._type === 'ATM' ? null : 0,
		// 	minResidualThresholdPercentage: this.model._type === 'ATM' ? null : '0%',
		// 	maxResidualThresholdPercentage: this.model._type === 'ATM' ? null : '0%',
		// 	status: 'Create',
		// 	isNew: true,
		// 	disableFields: this.model._type === 'ATM' ? false : true
		// })
		this.model.selectedDenomination.push({
			denomination: null,
			maxLoad:  null,
			minResidualThreshold:  null,
			maxResidualThreshold:  null,
			minResidualThresholdPercentage:  null,
			maxResidualThresholdPercentage:  null,
			status: 'Create',
			isNew: true,
			disableFields: false
		})
	}

	isNewRow(denomObj) {
		return denomObj.isNew === true;
	}

	editDenominationSelected(index) {
		const selectedDenomination = this.model.selectedDenomination.find((e, i) => i === index);
		this.model.selectedDenomination[index].isEditing = true; //disabled denomination

		this.model.selectedDenomination[index].disableFields = false;

		if (selectedDenomination.locationBalanceActiveId == null && selectedDenomination.id) {
			selectedDenomination.locationBalanceActiveStatus = 'Create';
			selectedDenomination.denominationStatus = 'Update';
		}
		else if (selectedDenomination.locationBalanceActiveId && selectedDenomination.id) {
			selectedDenomination.status = 'Update';
		}
	}

	deleteDenominationSelected(index) {
		const deletedDenom = this.model.selectedDenomination.splice(index, 1);
		if (!this.isNewRow(deletedDenom) && deletedDenom[0].id && deletedDenom[0].locationBalanceActiveId) {
			this.deletedLocationDenominationIds.push({
				locationDenominationId: deletedDenom[0].id,
				locationBalanceActiveId: deletedDenom[0].locationBalanceActiveId
			});
		}
		this.validateDenominationSelected();
		this.createLocationRecurringLoad();
	}

	validateDenominationSelected() {
		this.model.selectedDenomination = _.map(this.model.selectedDenomination, (mainObj, mainIndex) => {
			// if (mainObj.denomination && mainObj.denomination.coinFlag) {
			// 	mainObj.maxLoad = 0;
			// 	mainObj.minResidualThreshold = 0;
			// 	mainObj.maxResidualThreshold = 0;
			// 	mainObj.disableFields = true;
			// }
			// else {
			// 	mainObj.disableFields = false;
			// }

			mainObj.isDuplicate = false;

			let match = _.find(this.model.selectedDenomination, (compairObject, compairObjIndex) => {
				if (mainIndex > compairObjIndex && compairObject.denomination && mainObj.denomination && compairObject.denomination.Value && mainObj.denomination.Value) {
					return compairObject.denomination.Value === mainObj.denomination.Value;
				}
			});
			if (match) {
				mainObj.isDuplicate = true;
				return mainObj;
			} else {
				return mainObj;
			}
		});
		let isValid = this.model.selectedDenomination.map((obj) => {
			if (obj.isDuplicate) return true;
		})
		this.isValid = isValid.indexOf(true) >= 0 ? false : true;
		this.validateLocationSlotsDuplicate();
		this.checkForMaxLoadFaceValueDivisibility();
	}

	ngResidualPercentage(index, type) {
		const item = this.model.selectedDenomination[index];
		if (type == 'min' && item.minResidualThresholdPercentage && !String(item.minResidualThresholdPercentage).endsWith('%')) {
			item.minResidualThreshold = item.minResidualThresholdPercentage / 100 + '%';
			return item.minResidualThresholdPercentage = item.minResidualThresholdPercentage + '%';
		}

		else if (type == 'max' && item.maxResidualThresholdPercentage && !String(item.maxResidualThresholdPercentage).endsWith('%')) {
			item.maxResidualThreshold = item.maxResidualThresholdPercentage / 100 + '%';
			return item.maxResidualThresholdPercentage = item.maxResidualThresholdPercentage + '%';
		}
	}

	removeResidualPercentageSign(index, type) {
		const item = this.model.selectedDenomination[index];
		if (type == 'min' && item.minResidualThresholdPercentage && item.minResidualThresholdPercentage.endsWith('%')) {
			item.minResidualThreshold = item.minResidualThreshold.replace('%', '');
			return item.minResidualThresholdPercentage = item.minResidualThresholdPercentage.replace('%', '');
		}

		else if (type == 'max' && item.maxResidualThresholdPercentage && item.maxResidualThresholdPercentage.endsWith('%')) {
			item.maxResidualThreshold = item.maxResidualThreshold.replace('%', '');
			return item.maxResidualThresholdPercentage = item.maxResidualThresholdPercentage.replace('%', '');
		}
	}

	validateDisabledDenomFields() {
		if (!this.model.selectedDenomination) return;
		this.model.selectedDenomination.forEach((data) => {
			if (data.denomination && this.model._type !== 'ATM') {
				data.disableFields = true;
				// data.isDisabled = true;
				// data.isEditing = false;
			}
			else {
				data.disableFields = false;
				// data.isDisabled = false;
				// data.isEditing = true;
			}
		})
	}

	setAlwaysSwapRatio() {
		if (!this.model.bankSourceId || this.model._type !== 'ATM') {
			this.model.addToSwapRatio = null;
			return;
		}

		if (this.model.bankSourceId && !this.model.addToSwapRatio) this.model.addToSwapRatio = 'ALWAYS_ADD';
	}

	createLocationSlots() {
		if (!this.model.locationSlotDenominations.results) {
			this.model.locationSlotDenominations.results = [];
		}
		const mxdDenominations = this.model.locationSlotDenominations.results.filter(d => d.shiptypeId === 'MXD');
		this.model.locationSlots.push({
			denominationId: mxdDenominations[0] || null,
			slotTrackingId: '',
			isEditing: true,
			isDisabled: false
		});
		this.validateLocationSlotsDuplicate();
	}

	editLocationSlot(index) {
		const slot = this.model.locationSlots[index];
		slot.isEditing = true;
		slot.isDisabled = false;
		this.validateLocationSlotsDuplicate();
	}

	deleteLocationSlotsSelected(index) {
		if (!this.model.locationSlots) {
			this.model.locationSlots = [];
		}
		this.model.locationSlots.splice(index, 1);
		if (this.model.locationSlots.length === 0) {
			this.model.locationSlots = [];
		}
		this.validateLocationSlotsDuplicate();
	}

	validateLocationSlotsDuplicate() {
		if (!this.model.locationSlots || this.model.locationSlots.length === 0) {
			this.duplicateLocationSlotError = false;
			return true;
		}
		this.model.locationSlots.forEach(slot => slot.isDuplicate = false);
		let hasDuplicate = false;
		this.model.locationSlots.forEach((slot, index) => {
			const denomId = slot.denominationId && (slot.denominationId.id || slot.denominationId.Value || slot.denominationId);
			const trackingId = (slot.slotTrackingId || '').trim().toLowerCase();
			let match = this.model.locationSlots.find((other, otherIdx) => {
				if (index > otherIdx) {
					const otherDenomId = other.denominationId && (other.denominationId.id || other.denominationId.Value || other.denominationId);
					const otherTrackingId = (other.slotTrackingId || '').trim().toLowerCase();
					return denomId === otherDenomId && trackingId === otherTrackingId;
				}
				return false;
			});
			if (match) {
				slot.isDuplicate = true;
				hasDuplicate = true;
			}
		});
		this.duplicateLocationSlotError = hasDuplicate;
		return !hasDuplicate;
	}

	onFlowThresholdBlur() {
		if (this.model.balanceType === 'PERCENTAGE' && this.model.flowThreshold) {
			let val = parseFloat(this.model.flowThreshold.toString());
			if (!isNaN(val)) {
				this.model.flowThreshold = val + '%';
			}
		}
	}
	onFlowThresholdFocus() {
		if (this.model.balanceType === 'PERCENTAGE' && typeof this.model.flowThreshold === 'string') {
			this.model.flowThreshold = this.model.flowThreshold.replace('%', '');
		}
	}

	resetFlowThreshold() {
		this.model.flowThreshold = this.model.balanceType == 'PERCENTAGE' ? this.convertStr(0.2) / 100 : 0.2;
	}

	hasValidEmails(emailString, isRequired = false) {
		if (!emailString) return !isRequired;
		const emails = emailString.split(',').map(email => email.trim());
		const uniqueEmails = new Set();
		for (const email of emails) {
			if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
				return false;
			}
			if (uniqueEmails.has(email)) {
				return false;
			}
			uniqueEmails.add(email);
		}
		return true;
	}

	loadPickupRequestTimes() {
		return this.LocationService.getPickupRequestTimes()
			.then((data) => {
				if (data.status) {
					this.pickupRequestTimes = data.data;
				}
			})
			.catch((err) => {
				console.log('Error loading pickup request times:', err);
			});
	}

	onMarkerDragEnd($event) {
		this.model.latitude = $event.latLng.lat()
		this.model.longitude = $event.latLng.lng()
		if (this.model.latitude && this.model.longitude) {
			this.getAddressFromLatLng(this.model.latitude, this.model.longitude)
		}
		document.getElementById("lat").value = this.model.latitude;
		document.getElementById("lng").value = this.model.longitude;
	}

	toDecimalString(x) {
		return x.toFixed(Math.max(0, -Math.floor(Math.log10(Math.abs(x))) + 3));
	}
		
}

export default LocationEditController;



// WEBPACK FOOTER //
// ./client/app/components/location/edit/location.edit.controller.js